import { params, const_var } from "../../redux/reducers/reducer";
import * as utlis from "../../redux/reducers/utils";
import { ManufacturesDefaultDetails } from "../../Constants/constant";
import { calculateLeanBasicPrice, handleLeanUtility } from "./leanBuildingCalculation.helper";
import { calcInsulationPrice, calculateInsulation, commonFunctionForInsulationCalculations, heritageNoInsulation } from "../insulation_pricing/insulationPricing.helper";
import { trussCalcuateForGableLean } from "../building_component/truss/truss.helper";
// import { calculateLeanBasicPrice, handleLeanUtility } from "../../helper/leanBuildingCalculation.helper";

export const createLeanBuildingPriceCalculationHelpers = (getDeps = () => ({})) => {
	const getRuntimeDeps = () => (getDeps ? getDeps() : {}) || {};
	const cPforFLeanOnly = (data = const_var.leanGetDataFront, objIndex, newDW, options) => {
		const { ConvStr, removeDataFromArray, convertToTwoDecimalNumber, cP, setInsulation, isCustomInsulation } = getRuntimeDeps();
		let t_c_b = 0;
		let b = {};

		const prevLean = JSON.parse(JSON.stringify(const_var.post_data?.building?.leanto?.find((l) => l.leanto_type == 3) ?? {}));

		if (const_var.UpdatedPriceData.leanto == undefined) {
			const_var.UpdatedPriceData.leanto = [];
		}
		let UpdatePriceRecord = false;
		let frontLeanData = "";
		if (params.add_front_lean == true) {
			if (newDW == undefined && const_var.UpdatedPriceData.leanto.length > 0) {
				let leantoData = const_var.UpdatedPriceData.leanto.filter((data) => data.leanto_type == 3);
				if (leantoData.length > 0) {
					UpdatePriceRecord = true;
					frontLeanData = leantoData[0];
				}
			}
			removeDataFromArray(3);
			if (newDW != undefined) {
				const_var.UpdatedPriceData.leanto.push(newDW);
			}
			if (const_var.c_f_aCer[params.p_e_i] != undefined) {
				params.leanF_p_e_i = const_var.c_f_aCer[params.p_e_i]?.name;
			} else {
				params.leanF_p_e_i = params.p_e_i == "Select" ? "" : params.p_e_i;
			}
			let checkFrontCertificate =
				const_var.c_f_aCer[params.p_e_i] != undefined && params.p_e_i != "" && params.p_e_i != "Select" && params.leanF_p_e_i != "" && params.leanF_p_e_i != "0" && params.leanF_p_e_i != "other";
			let newMakeCertificateArrayFront = const_var.makeCertificateArrayFront;
			b = {
				leanto_type: 3,
				width: params.leanF_p_w,
				height: params.leanF_p_h,
				length: params.leanF_p_d,
				leanto_drop: "",
				front_wall: ConvStr(params.p_b_c_b_f_f),
				back_wall: ConvStr(params.p_b_c_b_f_b),
				side_wall: ConvStr(params.p_b_c_b_f_l),
				front_wall_price: 0,
				back_wall_price: 0,
				side_wall_price: 0,
				front_wall_vertical: params.p_v_w,
				back_wall_vertical: params.p_v_w,
				side_wall_vertical: params.p_v_w,
				certificate: newMakeCertificateArrayFront[params.leanF_p_e_i],
				right_wall: ConvStr(params.p_b_c_b_f_r),
				right_wall_price: 0,
				right_wall_vertical: params.p_v_w
			};
			if (const_var.isLTBuilding && params.leanStyle.front == "gable") {
				b.roof_length = params.frame_length;
			}

			var CalCulateRoofBasePrice = 0;
			var CalCulateRoofEndClosePrice = 0;
			var CalCulateRoofEndGablePrice = 0;
			var CalCulateRoofUtilityEndPrice = 0;

			if (params.add_storage_check_front == true) {
				data.side = data.side;
				data.panel = data.panel;
			} else {
				data.side = data.full_length_side != undefined ? data.full_length_side : data.side;
				data.panel = data.full_length_panel != undefined ? data.full_length_panel : data.panel;
			}
			if (const_var.UpdatedPriceData.leanto.length > 0) {
				let leantoData = const_var.UpdatedPriceData.leanto.filter((data) => data.leanto_type == 3);
				if (leantoData.length > 0) {
					UpdatePriceRecord = true;
					frontLeanData = leantoData[0];
				}
			}

			const frontLeanResult = calculateLeanBasicPrice({
				baseData: data.base,
				gaugeValue: const_var.g_v,
				p_r_s: params.p_r_s,
				UpdatePriceRecord,
				priceChangedFlag: const_var.UpdatedPriceData.front_lean_roof_style_price_changed,
				leanData: frontLeanData,
				currentTotal: t_c_b
			});

			b.basic_price = frontLeanResult.basic_price;
			t_c_b = frontLeanResult.total;
			CalCulateRoofBasePrice = frontLeanResult.roofBasePrice;

			b.wrappedLength = 0;
			const_var.lengthData.frontLean.porchLength = 0;
			if (params.add_left_front_lean_porch == true) {
				b.porch = { type: "front", length: params.lean_p_w + params.leanF_p_d };
				b.wrappedLength = params.lean_p_w + params.leanF_p_d;
				const_var.lengthData.frontLean.porchLength = params.lean_p_w;
			}
			if (params.add_right_front_lean_porch == true) {
				b.porch = { type: "front", length: params.leanR_p_w + params.leanF_p_d };
				b.wrappedLength = params.leanR_p_w + params.leanF_p_d;
				const_var.lengthData.frontLean.porchLength = params.leanR_p_w;
			}
			if (params.add_right_front_lean_porch == true && params.add_left_front_lean_porch == true) {
				b.porch = { type: "front", length: params.leanR_p_w + params.lean_p_w + params.leanF_p_d };
				b.wrappedLength = params.leanR_p_w + params.lean_p_w + params.leanF_p_d;
				const_var.lengthData.frontLean.porchLength = params.lean_p_w + params.leanR_p_w;
			}

			let heightFullData = data.full_length_side != undefined && data.full_length_side.length > 0 ? data.full_length_side : undefined;
			b.lean_has_double_leg = params.leanF_p_e_l;
			b.lean_has_double_leg_name = const_var.leanFHasDoublelegName;
			b.legstype = const_var.leanFLegstype;
			b.leanto_style = params.leanStyle.front;
			if (heightFullData?.length > 0) {
				if (const_var.g_v == 14) {
					if (params.leanF_p_e_l == true && const_var.leanFLegstype !== undefined && (const_var.leanFLegstype.includes("ladder") || const_var.leanFLegstype.includes("zigzag"))) {
						b.height_price =
							UpdatePriceRecord == true && const_var.UpdatedPriceData.front_lean_height_price_changed != true
								? frontLeanData.height_price
								: heightFullData[0].ladder_cost != undefined && heightFullData[0].ladder_cost != 0
									? heightFullData[0].ladder_cost
									: heightFullData[0].double_leg_baserail_cost != 0
										? heightFullData[0].double_leg_baserail_cost
										: heightFullData[0].leg_height_cost;
						t_c_b = parseFloat(t_c_b) + parseFloat(b.height_price);
					} else if (heightFullData[0]?.double_leg_baserail_cost != 0 && params.leanF_p_e_l == true && const_var.leanFLegstype !== undefined && const_var.leanFLegstype.includes("double")) {
						b.height_price =
							UpdatePriceRecord == true && const_var.UpdatedPriceData.front_lean_height_price_changed != true
								? frontLeanData.height_price
								: heightFullData[0].double_leg_baserail_cost != 0
									? heightFullData[0].double_leg_baserail_cost
									: heightFullData[0].leg_height_cost;
						t_c_b = parseFloat(t_c_b) + parseFloat(b.height_price);
					} else {
						b.height_price = UpdatePriceRecord == true && const_var.UpdatedPriceData.front_lean_height_price_changed != true ? frontLeanData.height_price : heightFullData[0].leg_height_cost;
						t_c_b = parseFloat(t_c_b) + parseFloat(b.height_price);
					}
				}
				if (const_var.g_v == 12) {
					if (params.leanF_p_e_l == true) {
						if (params.leanF_p_e_l == true && const_var.leanFLegstype !== undefined && (const_var.leanFLegstype.includes("ladder") || const_var.leanFLegstype.includes("zigzag"))) {
							b.height_price =
								UpdatePriceRecord == true && const_var.UpdatedPriceData.front_lean_height_price_changed != true
									? frontLeanData.height_price
									: heightFullData[0].ladder_cost != undefined && heightFullData[0].ladder_cost != 0
										? heightFullData[0].ladder_cost
										: heightFullData[0].leg_height_cost_12 != 0
											? heightFullData[0].leg_height_cost_12
											: heightFullData[0].leg_height_cost;
							t_c_b = parseFloat(t_c_b) + parseFloat(b.height_price);
						} else if (
							heightFullData[0].double_leg_baserail_cost_12 == 0 &&
							heightFullData[0].double_leg_baserail_cost == 0 &&
							const_var.leanFLegstype !== undefined &&
							const_var.leanFLegstype.includes("double")
						) {
							b.height_price =
								UpdatePriceRecord == true && const_var.UpdatedPriceData.front_lean_height_price_changed != true
									? frontLeanData.height_price
									: heightFullData[0].leg_height_cost_12 != 0
										? heightFullData[0].leg_height_cost_12
										: heightFullData[0].leg_height_cost;
							t_c_b = parseFloat(t_c_b) + parseFloat(b.height_price);
						} else {
							b.height_price =
								UpdatePriceRecord == true && const_var.UpdatedPriceData.front_lean_height_price_changed != true
									? frontLeanData.height_price
									: heightFullData[0].double_leg_baserail_cost_12 != 0
										? heightFullData[0].double_leg_baserail_cost_12
										: heightFullData[0].double_leg_baserail_cost;
							t_c_b = parseFloat(t_c_b) + parseFloat(b.height_price);
						}
					} else {
						b.height_price =
							UpdatePriceRecord == true && const_var.UpdatedPriceData.front_lean_height_price_changed != true
								? frontLeanData.height_price
								: heightFullData[0].leg_height_cost_12 != 0
									? heightFullData[0].leg_height_cost_12
									: heightFullData[0].leg_height_cost;
						t_c_b = parseFloat(t_c_b) + parseFloat(b.height_price);
					}
				}
			}

			let editCheckForHeritage =
				const_var.crmSetting.is_Edit == true &&
				params.m_s_n == 153 &&
				(params.p_r_s == 1 || params.p_r_s == 2) &&
				const_var.editAPIDataByResponse != undefined &&
				const_var.editAPIDataByResponse.data != undefined;

			let heritageNoInsulationCaseFrontLean = heritageNoInsulation(params, editCheckForHeritage, false, "frontLean");

			if (params.insulation.frontLean.insulationId == 0 && params.p_i_o != 0 && (params.p_f_i || params.p_r_o) && const_var.leanGetDataFront.insulation != undefined) {
				params.insulation.frontLean.insulationId = params.p_i_o;
			}
			if (params.insulation.frontLean.insulationId != 0 && heritageNoInsulationCaseFrontLean != true) {
				if (params.add_front_lean && data != "" && const_var.insulationArrayForLeantoFront && const_var.insulationArrayForLeantoFront[params.insulation.frontLean.insulationId] != undefined) {
					if (const_var.leanGetDataFront.insulation != undefined && isCustomInsulation("front")) {
						if (frontLeanData?.insulation_type?.insulation_wall) {
							const_var.insulationArrayForLeantoFront.insulation_wall = frontLeanData.insulation_type.insulation_wall;
						}
						calcInsulationPrice();

						b.insulation_price = UpdatePriceRecord && const_var.UpdatedPriceData.front_lean_insulation_price_changed != true ? frontLeanData.insulation_price : const_var.FLInsulationPrice;
						b.insulation_type = const_var.insulationArrayForLeantoFront[params.insulation.frontLean.insulationId];

						b.insulation_type.insulation_wall = const_var.insulationArrayForLeantoFront.insulation_wall;

						let chkForInsulationPrice = commonFunctionForInsulationCalculations(b.insulation_price, params.insulation.frontLean.insulationId);
						if (chkForInsulationPrice != true) {
							t_c_b = parseFloat(t_c_b) + parseFloat(b.insulation_price);
						}
					} else {
						let insulationId = params.p_i_o,
							p_f_i = params.p_f_i,
							p_r_o = params.p_r_o;

						const insulationRes = calculateInsulation(
							const_var.insulationArrayForLeantoFront[insulationId],
							p_f_i,
							p_r_o,
							"frontLean",
							params.add_storage_check_front,
							params.p_b_c_b_f_l,
							params.p_b_c_b_f_f,
							params.p_b_c_b_f_b,
							params.p_b_c_b_f_r,
							"front"
						);

						b.insulation = insulationRes.insulation;
						b.insulation_price =
							UpdatePriceRecord && const_var.UpdatedPriceData.front_lean_insulation_price_changed != true ? frontLeanData.insulation_price : convertToTwoDecimalNumber(insulationRes.insulationPrice);
						b.insulation_type = const_var.insulationArrayForLeantoFront[params.insulation.frontLean.insulationId];
						if (frontLeanData?.insulation_type?.insulation_wall) {
							const_var.insulationArrayForLeantoFront.insulation_wall = frontLeanData.insulation_type.insulation_wall;
						}
						b.insulation_type.insulation_wall = const_var.insulationArrayForLeantoFront.insulation_wall;
					}
				}
			} else {
				b.insulation_price = 0;
			}

			setInsulation(b);
			if (data?.gable_end[0]) {
				if (params.p_b_c_b_f_f == "Gable") {
					var ShowPrice = "";
					if (params.p_v_w == true) {
						if (params.leanF_p_e_i != "" && params.leanF_p_e_i != "other" && params.leanF_p_e_i != "0" && newMakeCertificateArrayFront?.[params.leanF_p_e_i]?.certified == 1) {
							ShowPrice =
								UpdatePriceRecord == true && const_var.UpdatedPriceData.front_lean_front_wall_price_changed != true
									? frontLeanData.front_wall_price
									: data.gable_end[0].vertical_certified + data.gable_end[0].certified;
						} else {
							ShowPrice =
								UpdatePriceRecord == true && const_var.UpdatedPriceData.front_lean_front_wall_price_changed != true
									? frontLeanData.front_wall_price
									: data.gable_end[0].uncertified + data.gable_end[0].vertical;
						}
					} else {
						if (params.leanF_p_e_i != "" && params.leanF_p_e_i != "other" && params.leanF_p_e_i != "0" && newMakeCertificateArrayFront?.[params.leanF_p_e_i]?.certified == 1) {
							ShowPrice = UpdatePriceRecord == true && const_var.UpdatedPriceData.front_lean_front_wall_price_changed != true ? frontLeanData.front_wall_price : data.gable_end[0].certified;
						} else {
							ShowPrice = UpdatePriceRecord == true && const_var.UpdatedPriceData.front_lean_front_wall_price_changed != true ? frontLeanData.front_wall_price : data.gable_end[0].uncertified;
						}
					}
					b.front_wall_price = ShowPrice;
					t_c_b = parseFloat(t_c_b) + parseFloat(b.front_wall_price);
					CalCulateRoofEndGablePrice = b.front_wall_price;
				}

				if (params.p_b_c_b_f_b == "Gable") {
					var ShowPrice = "";
					if (params.p_v_w == true) {
						if (params.leanF_p_e_i != "" && params.leanF_p_e_i != "other" && params.leanF_p_e_i != "0" && newMakeCertificateArrayFront?.[params.leanF_p_e_i]?.certified == 1) {
							ShowPrice =
								UpdatePriceRecord == true && const_var.UpdatedPriceData.front_lean_back_wall_price_changed != true
									? frontLeanData.back_wall_price
									: data.gable_end[0].vertical_certified + data.gable_end[0].certified;
						} else {
							ShowPrice =
								UpdatePriceRecord == true && const_var.UpdatedPriceData.front_lean_back_wall_price_changed != true
									? frontLeanData.back_wall_price
									: data.gable_end[0].uncertified + data.gable_end[0].vertical;
						}
					} else {
						if (params.leanF_p_e_i != "" && params.leanF_p_e_i != "other" && params.leanF_p_e_i != "0" && newMakeCertificateArrayFront?.[params.leanF_p_e_i]?.certified == 1) {
							ShowPrice = UpdatePriceRecord == true && const_var.UpdatedPriceData.front_lean_back_wall_price_changed != true ? frontLeanData.back_wall_price : data.gable_end[0].certified;
						} else {
							ShowPrice = UpdatePriceRecord == true && const_var.UpdatedPriceData.front_lean_back_wall_price_changed != true ? frontLeanData.back_wall_price : data.gable_end[0].uncertified;
						}
					}

					b.back_wall_price = ShowPrice;
					t_c_b = parseFloat(t_c_b) + parseFloat(b.back_wall_price);
					CalCulateRoofEndGablePrice = CalCulateRoofEndGablePrice + b.back_wall_price;
				}
			}
			if (data?.end[0]) {
				if (params.p_b_c_b_f_f == "Half_Close") {
					b.front_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.front_lean_front_wall_price_changed != true
							? frontLeanData.front_wall_price
							: params.p_v_w == true
								? (data.end[0].half_vertical_ends_cost + data.end[0].half_end_close_cost).toFixed(2)
								: data.end[0].half_end_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.front_wall_price);
				}
				if (params.p_b_c_b_f_f == "One_Fourth_Close") {
					b.front_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.front_lean_front_wall_price_changed != true
							? frontLeanData.front_wall_price
							: params.p_v_w == true
								? (data.end[0].one_fourth_vertical_ends_cost + data.end[0].one_fourth_end_close_cost).toFixed(2)
								: data.end[0].one_fourth_end_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.front_wall_price);
				}
				if (params.p_b_c_b_f_f == "Three_Fourth_Close") {
					b.front_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.front_lean_front_wall_price_changed != true
							? frontLeanData.front_wall_price
							: params.p_v_w == true
								? (data.end[0].three_fourth_vertical_ends_cost + data.end[0].three_fourth_end_close_cost).toFixed(2)
								: data.end[0].three_fourth_end_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.front_wall_price);
				}
				if (params.p_b_c_b_f_f == "Close") {
					b.front_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.front_lean_front_wall_price_changed != true
							? frontLeanData.front_wall_price
							: params.p_v_w == true
								? convertToTwoDecimalNumber(data.end[0].vertical_ends_cost + data.end[0].end_close_cost)
								: data.end[0].end_close_cost;
					t_c_b = parseFloat(t_c_b) + parseFloat(b.front_wall_price);
					CalCulateRoofEndClosePrice = b.front_wall_price;
				}
				if (params.p_b_c_b_f_f == "Half End" || params.p_b_c_b_f_f == "Half Dutch End") {
					let dutchPrice = 0;
					if (data.garage_door_frameout != undefined && params.p_b_c_b_f_f == "Half Dutch End") {
						dutchPrice = data.garage_door_frameout[0].dutch_cost;
					}
					b.front_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.front_lean_front_wall_price_changed != true
							? frontLeanData.front_wall_price
							: params.p_v_w == true
								? convertToTwoDecimalNumber(data.end[0].vertical_ends_cost / 2 + data.end[0].end_close_cost / 2 + dutchPrice)
								: utlis.convertToTwoDecimalNumber(data.end[0].end_close_cost / 2 + dutchPrice);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.front_wall_price);
					CalCulateRoofEndClosePrice = parseFloat(CalCulateRoofEndClosePrice) + parseFloat(b.front_wall_price);
				}

				if (params.p_b_c_b_f_b == "Half End" || params.p_b_c_b_f_b == "Half Dutch End") {
					let dutchPrice = 0;
					if (data.garage_door_frameout != undefined && params.p_b_c_b_f_b == "Half Dutch End") {
						dutchPrice = data.garage_door_frameout[0].dutch_cost;
					}
					b.back_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.front_lean_back_wall_price_changed != true
							? frontLeanData.back_wall_price
							: params.p_v_w == true
								? convertToTwoDecimalNumber(data.end[0].vertical_ends_cost / 2 + data.end[0].end_close_cost / 2 + dutchPrice)
								: convertToTwoDecimalNumber(data.end[0].end_close_cost / 2 + dutchPrice);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.back_wall_price);
					CalCulateRoofEndClosePrice = parseFloat(CalCulateRoofEndClosePrice) + parseFloat(b.back_wall_price);
				}

				if (params.p_b_c_b_f_b == "Half_Close") {
					b.back_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.front_lean_back_wall_price_changed != true
							? frontLeanData.back_wall_price
							: params.p_v_w == true
								? (data.end[0].half_vertical_ends_cost + data.end[0].half_end_close_cost).toFixed(2)
								: data.end[0].half_end_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.back_wall_price);
				}
				if (params.p_b_c_b_f_b == "One_Fourth_Close") {
					b.back_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.front_lean_back_wall_price_changed != true
							? frontLeanData.back_wall_price
							: params.p_v_w == true
								? (data.end[0].one_fourth_vertical_ends_cost + data.end[0].one_fourth_end_close_cost).toFixed(2)
								: data.end[0].one_fourth_end_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.back_wall_price);
				}
				if (params.p_b_c_b_f_b == "Three_Fourth_Close") {
					b.back_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.front_lean_back_wall_price_changed != true
							? frontLeanData.back_wall_price
							: params.p_v_w == true
								? (data.end[0].three_fourth_vertical_ends_cost + data.end[0].three_fourth_end_close_cost).toFixed(2)
								: data.end[0].three_fourth_end_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.back_wall_price);
				}
				if (params.p_b_c_b_f_b == "Close") {
					b.back_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.front_lean_back_wall_price_changed != true
							? frontLeanData.back_wall_price
							: params.p_v_w == true
								? convertToTwoDecimalNumber(data.end[0].vertical_ends_cost + data.end[0].end_close_cost)
								: data.end[0].end_close_cost;
					t_c_b = parseFloat(t_c_b) + parseFloat(b.back_wall_price);
					CalCulateRoofEndClosePrice = CalCulateRoofEndClosePrice + b.back_wall_price;
				}
			}
			if (data?.side[0]) {
				if (params.p_b_c_b_f_l == "Close") {
					b.side_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.front_lean_left_wall_price_changed != true
							? frontLeanData.side_wall_price
							: params.p_v_w == true
								? convertToTwoDecimalNumber(data.side[0].vertical_side_cost + data.side[0].side_close_cost)
								: data.side[0].side_close_cost;
					t_c_b = parseFloat(t_c_b) + parseFloat(b.side_wall_price);
				}
				if (params.p_b_c_b_f_l == "Half_Close") {
					b.side_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.front_lean_left_wall_price_changed != true
							? frontLeanData.side_wall_price
							: params.p_v_w == true
								? (data.side[0].half_vertical_side_cost + data.side[0].half_side_close_cost).toFixed(2)
								: data.side[0].half_side_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.side_wall_price);
				}
				if (params.p_b_c_b_f_l == "One_Fourth_Close") {
					b.side_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.front_lean_left_wall_price_changed != true
							? frontLeanData.side_wall_price
							: params.p_v_w == true
								? (data.side[0].one_fourth_vertical_side_cost + data.side[0].one_fourth_side_close_cost).toFixed(2)
								: data.side[0].one_fourth_side_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.side_wall_price);
				}
				if (params.p_b_c_b_f_l == "Three_Fourth_Close") {
					b.side_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.front_lean_left_wall_price_changed != true
							? frontLeanData.side_wall_price
							: params.p_v_w == true
								? (data.side[0].three_fourth_vertical_side_cost + data.side[0].three_fourth_side_close_cost).toFixed(2)
								: data.side[0].three_fourth_side_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.side_wall_price);
				}
			}
			if (data?.panel[0]) {
				if (params.p_b_c_b_f_l !== "Close" && params.p_b_c_b_f_l !== "Open" && params.p_b_c_b_f_l != "Half_Close" && params.p_b_c_b_f_l != "One_Fourth_Close" && params.p_b_c_b_f_l != "Three_Fourth_Close") {
					b.side_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.front_lean_left_wall_price_changed != true
							? frontLeanData.side_wall_price
							: params.p_v_w == true
								? data.panel[0].vertical_panel_cost * params.p_b_c_b_f_l
								: data.panel[0].cost * params.p_b_c_b_f_l;
					t_c_b = parseFloat(t_c_b) + parseFloat(b.side_wall_price);
				}
			}
			if (const_var.isLTBuilding) {
				if (params.p_b_c_b_f_r == "Close") {
					b.right_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.front_lean_right_wall_price_changed != true
							? frontLeanData.right_wall_price
							: params.p_v_w == true
								? convertToTwoDecimalNumber(data.side[0].vertical_side_cost + data.side[0].side_close_cost)
								: data.side[0].side_close_cost;
					t_c_b = parseFloat(t_c_b) + parseFloat(b.right_wall_price);
				}
				if (params.p_b_c_b_f_r == "Half_Close") {
					b.right_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.front_lean_right_wall_price_changed != true
							? frontLeanData.right_wall_price
							: params.p_v_w == true
								? (data.side[0].half_vertical_side_cost + data.side[0].half_side_close_cost).toFixed(2)
								: data.side[0].half_side_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.right_wall_price);
				}
				if (params.p_b_c_b_f_r == "One_Fourth_Close") {
					b.right_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.front_lean_right_wall_price_changed != true
							? frontLeanData.right_wall_price
							: params.p_v_w == true
								? (data.side[0].one_fourth_vertical_side_cost + data.side[0].one_fourth_side_close_cost).toFixed(2)
								: data.side[0].one_fourth_side_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.right_wall_price);
				}
				if (params.p_b_c_b_f_r == "Three_Fourth_Close") {
					b.right_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.front_lean_right_wall_price_changed != true
							? frontLeanData.right_wall_price
							: params.p_v_w == true
								? (data.side[0].three_fourth_vertical_side_cost + data.side[0].three_fourth_side_close_cost).toFixed(2)
								: data.side[0].three_fourth_side_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.right_wall_price);
				}
				if (params.p_b_c_b_f_r !== "Close" && params.p_b_c_b_f_r !== "Open" && params.p_b_c_b_f_r != "Half_Close" && params.p_b_c_b_f_r != "One_Fourth_Close" && params.p_b_c_b_f_r != "Three_Fourth_Close") {
					b.right_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.front_lean_right_wall_price_changed != true
							? frontLeanData.right_wall_price
							: params.p_v_w == true
								? data.panel[0].vertical_panel_cost * params.p_b_c_b_f_r
								: data.panel[0].cost * params.p_b_c_b_f_r;
					t_c_b = parseFloat(t_c_b) + parseFloat(b.right_wall_price);
				}
			}
			// Front  Lean utility calculation
			({ t_c_b, CalCulateRoofUtilityEndPrice } = handleLeanUtility({
				checkFlag: "add_storage_check_front",
				storageKey: "add_storage_front",
				positionKey: "frontLeanStoragePosition",
				depthKey: "leanF_p_d",
				sideCloseKey1: "p_b_c_b_f_l",
				sideCloseKey2: "p_b_c_b_f_r",
				wallKey: "p_f_w",
				leanStyleKey: "front",
				positionConditionType: "gt",
				leanData: frontLeanData,
				updatedFlagKey: "front_lean_utility_price_changed",
				params,
				data,
				const_var,
				b,
				t_c_b,
				UpdatePriceRecord,
				params,
				const_var
			}));
			if (const_var.b_r_p_l_to_a.length > 0 && const_var.b_r_p_l_to_a[params.b_l_t_r_pF] != undefined) {
				if (const_var.b_r_p_l_to_a[params.b_l_t_r_pF].cost_type == "%") {
					var splitVal =
						const_var.b_r_p_l_to_a[params.b_l_t_r_pF].percentage_of != undefined && const_var.b_r_p_l_to_a[params.b_l_t_r_pF].percentage_of != 0
							? const_var.b_r_p_l_to_a[params.b_l_t_r_pF].percentage_of.split(",")
							: 0;
					var splval = 0;
					if (splitVal != 0) {
						if (splitVal.includes("1") != false) {
							splval = splval + CalCulateRoofBasePrice;
						}
						if (splitVal.includes("2") != false) {
							if (CalCulateRoofUtilityEndPrice != 0) {
								splval = splval + CalCulateRoofUtilityEndPrice;
							}
							splval = splval + CalCulateRoofEndClosePrice;
						}
						if (splitVal.includes("3") != false) {
							splval = splval + CalCulateRoofEndGablePrice;
						}
					} else {
						splval = splval + CalCulateRoofBasePrice;
					}

					var finalCertPrice =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.front_lean_roof_pitch_price_changed != true
							? frontLeanData.roof_pitch_price
							: const_var.b_r_p_l_to_a[params.b_l_t_r_pF]
								? (splval * const_var.b_r_p_l_to_a[params.b_l_t_r_pF].cost) / 100
								: 0;
					b.roof_pitch = const_var.b_r_p_l_to_a[params.b_l_t_r_pF].roof_pitch;
					b.roof_pitch_name = const_var.b_r_p_l_to_a[params.b_l_t_r_pF].roof_pitch;
					b.roof_pitch_custom_name = const_var.b_r_p_l_to_a[params.b_l_t_r_pF]?.custom_name;
					b.roof_pitch_price = utlis.convertToTwoDecimalNumber(finalCertPrice);
					t_c_b = parseFloat(t_c_b) + parseFloat(finalCertPrice);
				} else {
					var finalCertPrice =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.front_lean_roof_pitch_price_changed != true
							? frontLeanData.roof_pitch_price
							: const_var.b_r_p_l_to_a[params.b_l_t_r_pF]
								? const_var.b_r_p_l_to_a[params.b_l_t_r_pF].cost
								: 0;
					t_c_b = parseFloat(t_c_b) + parseFloat(finalCertPrice);
					b.roof_pitch = const_var.b_r_p_l_to_a[params.b_l_t_r_pF].roof_pitch;
					b.roof_pitch_name = const_var.b_r_p_l_to_a[params.b_l_t_r_pF].roof_pitch;
					b.roof_pitch_custom_name = const_var.b_r_p_l_to_a[params.b_l_t_r_pF]?.custom_name;
					b.roof_pitch_price = utlis.convertToTwoDecimalNumber(finalCertPrice);
				}
			} else {
				b.roof_pitch = "3/12";
				b.roof_pitch_name = "3/12";
				b.roof_pitch_price = 0;
			}
			if (checkFrontCertificate) {
			}
			if (params.leanF_p_e_i == "other") {
				b.certificate = { gauge: 0, certified: 1, has_double_leg: 0, has_ladder_leg: 0, has_other_leg: 0, height: 0, id: -1, cost: 0, is_default: "no", length: 0, map_id: 0, name: "Other" };
				b.certificate_other_name = params.leanF_p_e_i_other != "" ? params.leanF_p_e_i_other : "Other";
				b.certificate_price = UpdatePriceRecord == true && const_var.UpdatedPriceData.certificate_price_changed != true ? frontLeanData.certificate_price : 0;
			}

			if (params.continous_left_lean == true) {
				b.continous_lean = true;
			} else {
				b.continous_lean = false;
			}
			b.edit_truss_name =
				const_var.c_m_a[params.p_b_t].trussType != undefined && const_var.c_m_a[params.p_b_t].trussType.length > 0 ? params["trussType"] : const_var.c_m_a[params.p_b_t].trussType[0].name.replace(/[0-9]/g, "");

			if (b.leanto_style === "gable") {
				const trussPrice = trussCalcuateForGableLean(params, 0, b, frontLeanData, UpdatePriceRecord);
				if (trussPrice > 0) {
					t_c_b += trussPrice;
				}
			}

			b.pricing_data = data;

			b.t_c_b = parseFloat(t_c_b);
			const_var.leanto.push(b);

			const_var.UpdatedPriceData.leanto.push(b);
		} else {
			removeDataFromArray(3);
		}

		cP(const_var.a_p_d_a, true);
	};

	const cPforBLeanOnly = (data = const_var.leanGetDataBack, objIndex, newDW, options) => {
		const { ConvStr, removeDataFromArray, convertToTwoDecimalNumber, cP, setInsulation, isCustomInsulation } = getRuntimeDeps();
		let t_c_b = 0;
		let b = {};
		const prevLean = JSON.parse(JSON.stringify(const_var.post_data?.building?.leanto?.find((l) => l.leanto_type == 4) ?? {}));
		if (const_var.UpdatedPriceData.leanto == undefined) {
			const_var.UpdatedPriceData.leanto = [];
		}
		let UpdatePriceRecord = false;
		let backLeanData = "";
		if (params.add_back_lean == true) {
			if (newDW == undefined && const_var.UpdatedPriceData.leanto.length > 0) {
				let leantoData = const_var.UpdatedPriceData.leanto.filter((data) => data.leanto_type == 4);
				if (leantoData.length > 0) {
					UpdatePriceRecord = true;
					backLeanData = leantoData[0];
				}
			}
			removeDataFromArray(4);
			if (newDW != undefined) {
				const_var.UpdatedPriceData.leanto.push(newDW);
			}

			if (const_var.c_f_aCer[params.p_e_i] != undefined) {
				params.leanB_p_e_i = const_var.c_f_aCer[params.p_e_i]?.name;
			} else {
				params.leanB_p_e_i = params.p_e_i == "Select" ? "" : params.p_e_i;
			}
			// }

			let checkBackCertificate =
				const_var.c_f_aCer[params.p_e_i] != undefined && params.p_e_i != "" && params.p_e_i != "Select" && params.leanB_p_e_i != "" && params.leanB_p_e_i != "0" && params.leanB_p_e_i != "other";
			let newMakeCertificateArrayBack = const_var.makeCertificateArrayBack;
			b = {
				leanto_type: 4,
				width: params.leanB_p_w,
				height: params.leanB_p_h,
				length: params.leanB_p_d,
				leanto_drop: "",
				front_wall: ConvStr(params.p_b_c_b_b_f),
				back_wall: ConvStr(params.p_b_c_b_b_b),
				side_wall: ConvStr(params.p_b_c_b_b_l),
				front_wall_price: 0,
				back_wall_price: 0,
				side_wall_price: 0,
				front_wall_vertical: params.p_v_w,
				back_wall_vertical: params.p_v_w,
				side_wall_vertical: params.p_v_w,
				certificate: newMakeCertificateArrayBack[params.leanB_p_e_i],
				right_wall: ConvStr(params.p_b_c_b_b_r),
				right_wall_price: 0,
				right_wall_vertical: params.p_v_w
			};
			//a.concat(b);
			if (const_var.isLTBuilding && params.leanStyle.back == "gable") {
				b.roof_length = params.frame_length;
			}

			var CalCulateRoofBasePrice = 0;
			var CalCulateRoofEndClosePrice = 0;
			var CalCulateRoofEndGablePrice = 0;
			var CalCulateRoofUtilityEndPrice = 0;

			if (params.add_storage_check_back == true) {
				data.side = data.side;
				data.panel = data.panel;
			} else {
				data.side = data.full_length_side != undefined ? data.full_length_side : data.side;
				data.panel = data.full_length_panel != undefined ? data.full_length_panel : data.panel;
			}
			if (const_var.UpdatedPriceData.leanto.length > 0) {
				let leantoData = const_var.UpdatedPriceData.leanto.filter((data) => data.leanto_type == 4);
				if (leantoData.length > 0) {
					UpdatePriceRecord = true;
					backLeanData = leantoData[0];
				}
			}

			const BackLeanResult = calculateLeanBasicPrice({
				baseData: data.base,
				gaugeValue: const_var.g_v,
				p_r_s: params.p_r_s,
				UpdatePriceRecord,
				priceChangedFlag: const_var.UpdatedPriceData.back_lean_roof_style_price_changed,
				leanData: backLeanData,
				currentTotal: t_c_b
			});

			b.basic_price = BackLeanResult.basic_price;
			t_c_b = BackLeanResult.total;
			CalCulateRoofBasePrice = BackLeanResult.roofBasePrice;
			b.wrappedLength = 0;
			const_var.lengthData.backLean.porchLength = 0;
			if (params.add_left_back_lean_porch == true) {
				b.porch = { type: "back", length: params.lean_p_w + params.leanB_p_d };
				b.wrappedLength = params.lean_p_w + params.leanB_p_d;
				const_var.lengthData.backLean.porchLength = params.lean_p_w;
			}
			if (params.add_right_back_lean_porch == true) {
				b.porch = { type: "back", length: params.leanR_p_w + params.leanB_p_d };
				b.wrappedLength = params.leanR_p_w + params.leanB_p_d;
				const_var.lengthData.backLean.porchLength = params.leanR_p_w;
			}
			if (params.add_right_back_lean_porch == true && params.add_left_back_lean_porch == true) {
				b.porch = { type: "back", length: params.leanR_p_w + params.lean_p_w + params.leanB_p_d };
				b.wrappedLength = params.leanR_p_w + params.lean_p_w + params.leanB_p_d;
				const_var.lengthData.backLean.porchLength = params.lean_p_w + params.leanR_p_w;
			}
			let heightFullData = data.full_length_side != undefined && data.full_length_side.length > 0 ? data.full_length_side : [];
			console.log("heightFullData", heightFullData);
			b.lean_has_double_leg = params.leanB_p_e_l;
			b.lean_has_double_leg_name = const_var.leanBHasDoublelegName;
			b.legstype = const_var.leanBLegstype;
			b.leanto_style = params.leanStyle.back;
			if (heightFullData?.length > 0) {
				if (const_var.g_v == 14 && heightFullData?.length > 0) {
					if (params.leanB_p_e_l == true && const_var.leanBLegstype !== undefined && (const_var.leanBLegstype.includes("ladder") || const_var.leanBLegstype.includes("zigzag"))) {
						b.height_price =
							UpdatePriceRecord == true && const_var.UpdatedPriceData.back_lean_height_price_changed != true
								? backLeanData.height_price
								: heightFullData[0].ladder_cost != undefined && heightFullData[0].ladder_cost != 0
									? heightFullData[0].ladder_cost
									: heightFullData[0].double_leg_baserail_cost != 0
										? heightFullData[0].double_leg_baserail_cost
										: heightFullData[0].leg_height_cost;
						t_c_b = parseFloat(t_c_b) + parseFloat(b.height_price);
						{
							console.log("heightFullData", heightFullData);
						}
					} else if (heightFullData[0]?.double_leg_baserail_cost != 0 && params.leanB_p_e_l == true && const_var.leanBLegstype !== undefined && const_var.leanBLegstype.includes("double")) {
						b.height_price =
							UpdatePriceRecord == true && const_var.UpdatedPriceData.back_lean_height_price_changed != true
								? backLeanData.height_price
								: heightFullData[0].double_leg_baserail_cost != 0
									? heightFullData[0].double_leg_baserail_cost
									: heightFullData[0].leg_height_cost;
						t_c_b = parseFloat(t_c_b) + parseFloat(b.height_price);
					} else {
						b.height_price = UpdatePriceRecord == true && const_var.UpdatedPriceData.back_lean_height_price_changed != true ? backLeanData.height_price : heightFullData[0].leg_height_cost;
						t_c_b = parseFloat(t_c_b) + parseFloat(b.height_price);
					}
				}
				if (const_var.g_v == 12) {
					if (params.leanB_p_e_l == true) {
						if (params.leanB_p_e_l == true && const_var.leanBLegstype !== undefined && (const_var.leanBLegstype.includes("ladder") || const_var.leanBLegstype.includes("zigzag"))) {
							b.height_price =
								UpdatePriceRecord == true && const_var.UpdatedPriceData.back_lean_height_price_changed != true
									? backLeanData.height_price
									: heightFullData[0].ladder_cost != undefined && heightFullData[0].ladder_cost != 0
										? heightFullData[0].ladder_cost
										: heightFullData[0].double_leg_baserail_cost_12 != 0
											? heightFullData[0].double_leg_baserail_cost_12
											: heightFullData[0].leg_height_cost;
							t_c_b = parseFloat(t_c_b) + parseFloat(b.height_price);
							// b.leanB_has_double_leg_price = b.height_price;
						} else if (
							heightFullData[0].double_leg_baserail_cost_12 == 0 &&
							heightFullData[0].double_leg_baserail_cost == 0 &&
							const_var.leanBLegstype !== undefined &&
							const_var.leanBLegstype.includes("double")
						) {
							b.height_price =
								UpdatePriceRecord == true && const_var.UpdatedPriceData.back_lean_height_price_changed != true
									? backLeanData.height_price
									: heightFullData[0].double_leg_baserail_cost_12 != 0
										? heightFullData[0].double_leg_baserail_cost_12
										: heightFullData[0].leg_height_cost;
							t_c_b = parseFloat(t_c_b) + parseFloat(b.height_price);
						} else {
							b.height_price =
								UpdatePriceRecord == true && const_var.UpdatedPriceData.back_lean_height_price_changed != true
									? backLeanData.height_price
									: heightFullData[0].double_leg_baserail_cost_12 != 0
										? heightFullData[0].double_leg_baserail_cost_12
										: heightFullData[0].double_leg_baserail_cost;
							t_c_b = parseFloat(t_c_b) + parseFloat(b.height_price);
						}
					} else {
						b.height_price =
							UpdatePriceRecord == true && const_var.UpdatedPriceData.back_lean_height_price_changed != true
								? backLeanData.height_price
								: heightFullData[0].leg_height_cost_12 != 0
									? heightFullData[0].leg_height_cost_12
									: heightFullData[0].leg_height_cost;
						t_c_b = parseFloat(t_c_b) + parseFloat(b.height_price);
					}
				}
			}

			let editCheckForHeritage =
				const_var.crmSetting.is_Edit == true &&
				params.m_s_n == 153 &&
				(params.p_r_s == 1 || params.p_r_s == 2) &&
				const_var.editAPIDataByResponse != undefined &&
				const_var.editAPIDataByResponse.data != undefined;

			let heritageNoInsulationCaseBackLean = heritageNoInsulation(params, editCheckForHeritage, false, "backLean");

			if (params.insulation.backLean.insulationId == 0 && params.p_i_o != 0 && (params.p_f_i || params.p_r_o) && const_var.leanGetDataBack.insulation != undefined) {
				params.insulation.backLean.insulationId = params.p_i_o;
			}
			if (params.insulation.backLean.insulationId != 0 && heritageNoInsulationCaseBackLean != true) {
				if (params.add_back_lean && data != "" && const_var.insulationArrayForLeantoBack && const_var.insulationArrayForLeantoBack[params.insulation.backLean.insulationId] != undefined) {
					if (const_var.leanGetDataBack.insulation != undefined && isCustomInsulation("back")) {
						if (backLeanData?.insulation_type?.insulation_wall) {
							const_var.insulationArrayForLeantoBack.insulation_wall = backLeanData.insulation_type.insulation_wall;
						}
						calcInsulationPrice();

						b.insulation_price = UpdatePriceRecord && const_var.UpdatedPriceData.back_lean_insulation_price_changed != true ? backLeanData.insulation_price : const_var.BLInsulationPrice;

						b.insulation_type = const_var.insulationArrayForLeantoBack[params.insulation.backLean.insulationId];

						b.insulation_type.insulation_wall = const_var.insulationArrayForLeantoBack.insulation_wall;

						let chkForInsulationPrice = commonFunctionForInsulationCalculations(b.insulation_price, params.insulation.backLean.insulationId);
						if (chkForInsulationPrice != true) {
							t_c_b = parseFloat(t_c_b) + parseFloat(b.insulation_price);
						}
					} else {
						let insulationId = params.p_i_o,
							p_f_i = params.p_f_i,
							p_r_o = params.p_r_o;

						const insulationRes = calculateInsulation(
							const_var.insulationArrayForLeantoBack[insulationId],
							p_f_i,
							p_r_o,
							"backLean",
							params.add_storage_check_back,
							params.p_b_c_b_b_l,
							params.p_b_c_b_b_f,
							params.p_b_c_b_b_b,
							params.p_b_c_b_b_l,
							"back"
						);
						b.insulation = insulationRes.insulation;
						b.insulation_price =
							UpdatePriceRecord && const_var.UpdatedPriceData.back_lean_insulation_price_changed != true ? backLeanData.insulation_price : convertToTwoDecimalNumber(insulationRes.insulationPrice);
						b.insulation_type = const_var.insulationArrayForLeantoBack[params.insulation.backLean.insulationId];
						if (backLeanData?.insulation_type?.insulation_wall) {
							const_var.insulationArrayForLeantoBack.insulation_wall = backLeanData.insulation_type.insulation_wall;
						}
						b.insulation_type.insulation_wall = const_var.insulationArrayForLeantoBack.insulation_wall;
					}
				}
			} else {
				b.insulation_price = 0;
			}

			setInsulation(b);
			if (data?.gable_end[0]) {
				if (params.p_b_c_b_b_f == "Gable") {
					var ShowPrice = "";
					if (params.p_v_w == true) {
						if (params.leanB_p_e_i != "" && params.leanB_p_e_i != "other" && params.leanB_p_e_i != "0" && newMakeCertificateArrayBack?.[params.leanB_p_e_i]?.certified == 1) {
							ShowPrice =
								UpdatePriceRecord == true && const_var.UpdatedPriceData.back_lean_front_wall_price_changed != true
									? backLeanData.front_wall_price
									: data.gable_end[0].vertical_certified + data.gable_end[0].certified;
						} else {
							ShowPrice =
								UpdatePriceRecord == true && const_var.UpdatedPriceData.back_lean_front_wall_price_changed != true
									? backLeanData.front_wall_price
									: data.gable_end[0].uncertified + data.gable_end[0].vertical;
						}
					} else {
						if (params.leanB_p_e_i != "" && params.leanB_p_e_i != "other" && params.leanB_p_e_i != "0" && newMakeCertificateArrayBack?.[params.leanB_p_e_i]?.certified == 1) {
							ShowPrice = UpdatePriceRecord == true && const_var.UpdatedPriceData.back_lean_front_wall_price_changed != true ? backLeanData.front_wall_price : data.gable_end[0].certified;
						} else {
							ShowPrice = UpdatePriceRecord == true && const_var.UpdatedPriceData.back_lean_front_wall_price_changed != true ? backLeanData.front_wall_price : data.gable_end[0].uncertified;
						}
					}
					b.front_wall_price = ShowPrice;
					t_c_b = parseFloat(t_c_b) + parseFloat(b.front_wall_price);
					CalCulateRoofEndGablePrice = b.front_wall_price;
				}
				if (params.p_b_c_b_b_b == "Gable") {
					var ShowPrice = "";
					if (params.p_v_w == true) {
						if (params.leanB_p_e_i != "" && params.leanB_p_e_i != "other" && params.leanB_p_e_i != "0" && newMakeCertificateArrayBack?.[params.leanB_p_e_i]?.certified == 1) {
							ShowPrice =
								UpdatePriceRecord == true && const_var.UpdatedPriceData.back_lean_back_wall_price_changed != true
									? backLeanData.back_wall_price
									: data.gable_end[0].vertical_certified + data.gable_end[0].certified;
						} else {
							ShowPrice =
								UpdatePriceRecord == true && const_var.UpdatedPriceData.back_lean_back_wall_price_changed != true
									? backLeanData.back_wall_price
									: data.gable_end[0].uncertified + data.gable_end[0].vertical;
						}
					} else {
						if (params.leanB_p_e_i != "" && params.leanB_p_e_i != "other" && params.leanB_p_e_i != "0" && newMakeCertificateArrayBack?.[params.leanB_p_e_i]?.certified == 1) {
							ShowPrice = UpdatePriceRecord == true && const_var.UpdatedPriceData.back_lean_back_wall_price_changed != true ? backLeanData.back_wall_price : data.gable_end[0].certified;
						} else {
							ShowPrice = UpdatePriceRecord == true && const_var.UpdatedPriceData.back_lean_back_wall_price_changed != true ? backLeanData.back_wall_price : data.gable_end[0].uncertified;
						}
					}
					b.back_wall_price = ShowPrice;
					t_c_b = parseFloat(t_c_b) + parseFloat(b.back_wall_price);
					CalCulateRoofEndGablePrice = CalCulateRoofEndGablePrice + b.back_wall_price;
				}
			}
			if (data?.end[0]) {
				if (params.p_b_c_b_b_f == "Half_Close") {
					b.front_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.back_lean_front_wall_price_changed != true
							? backLeanData.front_wall_price
							: params.p_v_w == true
								? (data.end[0].half_vertical_ends_cost + data.end[0].half_end_close_cost).toFixed(2)
								: data.end[0].half_end_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.front_wall_price);
				}
				if (params.p_b_c_b_b_f == "One_Fourth_Close") {
					b.front_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.back_lean_front_wall_price_changed != true
							? backLeanData.front_wall_price
							: params.p_v_w == true
								? (data.end[0].one_fourth_vertical_ends_cost + data.end[0].one_fourth_end_close_cost).toFixed(2)
								: data.end[0].one_fourth_end_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.front_wall_price);
				}
				if (params.p_b_c_b_b_f == "Three_Fourth_Close") {
					b.front_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.back_lean_front_wall_price_changed != true
							? backLeanData.front_wall_price
							: params.p_v_w == true
								? (data.end[0].three_fourth_vertical_ends_cost + data.end[0].three_fourth_end_close_cost).toFixed(2)
								: data.end[0].three_fourth_end_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.front_wall_price);
				}
				if (params.p_b_c_b_b_f == "Close") {
					b.front_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.back_lean_front_wall_price_changed != true
							? backLeanData.front_wall_price
							: params.p_v_w == true
								? data.end[0].vertical_ends_cost + data.end[0].end_close_cost
								: data.end[0].end_close_cost;
					t_c_b = parseFloat(t_c_b) + parseFloat(b.front_wall_price);
					CalCulateRoofEndClosePrice = b.front_wall_price;
				}
				if (params.p_b_c_b_b_f == "Half End" || params.p_b_c_b_b_f == "Half Dutch End") {
					let dutchPrice = 0;
					if (data.garage_door_frameout != undefined && params.p_b_c_b_b_f == "Half Dutch End") {
						dutchPrice = data.garage_door_frameout[0].dutch_cost;
					}
					b.front_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.back_lean_front_wall_price_changed != true
							? backLeanData.front_wall_price
							: params.p_v_w == true
								? convertToTwoDecimalNumber(data.end[0].vertical_ends_cost / 2 + data.end[0].end_close_cost / 2 + dutchPrice)
								: utlis.convertToTwoDecimalNumber(data.end[0].end_close_cost / 2 + dutchPrice);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.front_wall_price);
					CalCulateRoofEndClosePrice = parseFloat(CalCulateRoofEndClosePrice) + parseFloat(b.front_wall_price);
				}

				if (params.p_b_c_b_b_b == "Half End" || params.p_b_c_b_b_b == "Half Dutch End") {
					let dutchPrice = 0;
					if (data.garage_door_frameout != undefined && params.p_b_c_b_b_b == "Half Dutch End") {
						dutchPrice = data.garage_door_frameout[0].dutch_cost;
					}
					b.back_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.back_lean_back_wall_price_changed != true
							? backLeanData.back_wall_price
							: params.p_v_w == true
								? convertToTwoDecimalNumber(data.end[0].vertical_ends_cost / 2 + data.end[0].end_close_cost / 2 + dutchPrice)
								: convertToTwoDecimalNumber(data.end[0].end_close_cost / 2 + dutchPrice);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.back_wall_price);
					CalCulateRoofEndClosePrice = parseFloat(CalCulateRoofEndClosePrice) + parseFloat(b.back_wall_price);
				}
				if (params.p_b_c_b_b_b == "Half_Close") {
					b.back_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.back_lean_back_wall_price_changed != true
							? backLeanData.back_wall_price
							: params.p_v_w == true
								? (data.end[0].half_vertical_ends_cost + data.end[0].half_end_close_cost).toFixed(2)
								: data.end[0].half_end_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.back_wall_price);
				}
				if (params.p_b_c_b_b_b == "One_Fourth_Close") {
					b.back_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.back_lean_back_wall_price_changed != true
							? backLeanData.back_wall_price
							: params.p_v_w == true
								? (data.end[0].one_fourth_vertical_ends_cost + data.end[0].one_fourth_end_close_cost).toFixed(2)
								: data.end[0].one_fourth_end_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.back_wall_price);
				}
				if (params.p_b_c_b_b_b == "Three_Fourth_Close") {
					b.back_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.back_lean_back_wall_price_changed != true
							? backLeanData.back_wall_price
							: params.p_v_w == true
								? (data.end[0].three_fourth_vertical_ends_cost + data.end[0].three_fourth_end_close_cost).toFixed(2)
								: data.end[0].three_fourth_end_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.back_wall_price);
				}
				if (params.p_b_c_b_b_b == "Close") {
					b.back_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.back_lean_back_wall_price_changed != true
							? backLeanData.back_wall_price
							: params.p_v_w == true
								? data.end[0].vertical_ends_cost + data.end[0].end_close_cost
								: data.end[0].end_close_cost;
					t_c_b = parseFloat(t_c_b) + parseFloat(b.back_wall_price);
					CalCulateRoofEndClosePrice = CalCulateRoofEndClosePrice + b.back_wall_price;
				}
			}
			if (data?.side[0]) {
				if (params.p_b_c_b_b_l == "Close") {
					b.side_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.back_lean_left_wall_price_changed != true
							? backLeanData.side_wall_price
							: params.p_v_w == true
								? convertToTwoDecimalNumber(data.side[0].vertical_side_cost + data.side[0]?.side_close_cost)
								: convertToTwoDecimalNumber(data.side[0]?.side_close_cost);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.side_wall_price);
				}
				if (params.p_b_c_b_b_l == "Half_Close") {
					b.side_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.back_lean_left_wall_price_changed != true
							? backLeanData.side_wall_price
							: params.p_v_w == true
								? (data.side[0].half_vertical_side_cost + data.side[0].half_side_close_cost).toFixed(2)
								: data.side[0].half_side_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.side_wall_price);
				}
				if (params.p_b_c_b_b_l == "One_Fourth_Close") {
					b.side_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.back_lean_left_wall_price_changed != true
							? backLeanData.side_wall_price
							: params.p_v_w == true
								? (data.side[0].one_fourth_vertical_side_cost + data.side[0].one_fourth_side_close_cost).toFixed(2)
								: data.side[0].one_fourth_side_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.side_wall_price);
				}
				if (params.p_b_c_b_b_l == "Three_Fourth_Close") {
					b.side_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.back_lean_left_wall_price_changed != true
							? backLeanData.side_wall_price
							: params.p_v_w == true
								? (data.side[0].three_fourth_vertical_side_cost + data.side[0].three_fourth_side_close_cost).toFixed(2)
								: data.side[0].three_fourth_side_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.side_wall_price);
				}
			}
			if (data?.panel[0]) {
				if (params.p_b_c_b_b_l !== "Close" && params.p_b_c_b_b_l !== "Open" && params.p_b_c_b_b_l != "Half_Close" && params.p_b_c_b_b_l != "One_Fourth_Close" && params.p_b_c_b_b_l != "Three_Fourth_Close") {
					b.side_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.back_lean_left_wall_price_changed != true
							? backLeanData.side_wall_price
							: params.p_v_w == true
								? data.panel[0].vertical_panel_cost * params.p_b_c_b_b_l
								: data.panel[0].cost * params.p_b_c_b_b_l;
					t_c_b = parseFloat(t_c_b) + parseFloat(b.side_wall_price);
				}
			}
			if (const_var.isLTBuilding) {
				if (params.p_b_c_b_b_r == "Close") {
					b.right_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.back_lean_right_wall_price_changed != true
							? backLeanData.right_wall_price
							: params.p_v_w == true
								? convertToTwoDecimalNumber(data.side[0].vertical_side_cost + data.side[0].side_close_cost)
								: convertToTwoDecimalNumber(data.side[0].side_close_cost);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.right_wall_price);
				}
				if (params.p_b_c_b_b_r == "Half_Close") {
					b.right_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.back_lean_right_wall_price_changed != true
							? backLeanData.right_wall_price
							: params.p_v_w == true
								? (data.side[0].half_vertical_side_cost + data.side[0].half_side_close_cost).toFixed(2)
								: data.side[0].half_side_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.right_wall_price);
				}
				if (params.p_b_c_b_b_r == "One_Fourth_Close") {
					b.right_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.back_lean_right_wall_price_changed != true
							? backLeanData.right_wall_price
							: params.p_v_w == true
								? (data.side[0].one_fourth_vertical_side_cost + data.side[0].one_fourth_side_close_cost).toFixed(2)
								: data.side[0].one_fourth_side_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.right_wall_price);
				}
				if (params.p_b_c_b_b_r == "Three_Fourth_Close") {
					b.right_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.back_lean_right_wall_price_changed != true
							? backLeanData.right_wall_price
							: params.p_v_w == true
								? (data.side[0].three_fourth_vertical_side_cost + data.side[0].three_fourth_side_close_cost).toFixed(2)
								: data.side[0].three_fourth_side_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.right_wall_price);
				}
				if (params.p_b_c_b_b_r !== "Close" && params.p_b_c_b_b_r !== "Open" && params.p_b_c_b_b_r != "Half_Close" && params.p_b_c_b_b_r != "One_Fourth_Close" && params.p_b_c_b_b_r != "Three_Fourth_Close") {
					b.right_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.back_lean_right_wall_price_changed != true
							? backLeanData.right_wall_price
							: params.p_v_w == true
								? data.panel[0].vertical_panel_cost * params.p_b_c_b_b_r
								: data.panel[0].cost * params.p_b_c_b_b_r;
					t_c_b = parseFloat(t_c_b) + parseFloat(b.right_wall_price);
				}
			}
			// Back Lean utility calculation
			({ t_c_b, CalCulateRoofUtilityEndPrice } = handleLeanUtility({
				checkFlag: "add_storage_check_back",
				storageKey: "add_storage_back",
				positionKey: "backLeanStoragePosition",
				depthKey: "leanB_p_d",
				sideCloseKey1: "p_b_c_b_b_l",
				positionConditionType: "gt",
				sideCloseKey2: "p_b_c_b_b_r",
				wallKey: "p_b_w",
				leanStyleKey: "back",
				leanData: backLeanData,
				updatedFlagKey: "back_lean_utility_price_changed",
				data,
				b,
				t_c_b,
				UpdatePriceRecord,
				params, // ✅ ADD THIS
				const_var
			}));
			// console.log(t_c_b,"t_c_b2222444444",t_c_b)
			if (const_var.b_r_p_l_to_a.length > 0 && const_var.b_r_p_l_to_a[params.b_l_t_r_pB] != undefined) {
				if (const_var.b_r_p_l_to_a[params.b_l_t_r_pB].cost_type == "%") {
					var splitVal =
						const_var.b_r_p_l_to_a[params.b_l_t_r_pB].percentage_of != undefined && const_var.b_r_p_l_to_a[params.b_l_t_r_pB].percentage_of != 0
							? const_var.b_r_p_l_to_a[params.b_l_t_r_pB].percentage_of.split(",")
							: 0;
					var splval = 0;
					if (splitVal != 0) {
						if (splitVal.includes("1") != false) {
							splval = splval + CalCulateRoofBasePrice;
						}
						if (splitVal.includes("2") != false) {
							if (CalCulateRoofUtilityEndPrice != 0) {
								splval = splval + CalCulateRoofUtilityEndPrice;
							}
							splval = splval + CalCulateRoofEndClosePrice;
						}
						if (splitVal.includes("3") != false) {
							splval = splval + CalCulateRoofEndGablePrice;
						}
					} else {
						splval = splval + CalCulateRoofBasePrice;
					}
					var finalCertPrice =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.back_lean_roof_pitch_price_changed != true
							? backLeanData.roof_pitch_price
							: const_var.b_r_p_l_to_a[params.b_l_t_r_pB]
								? (splval * const_var.b_r_p_l_to_a[params.b_l_t_r_pB].cost) / 100
								: 0;
					b.roof_pitch = const_var.b_r_p_l_to_a[params.b_l_t_r_pB].roof_pitch;
					b.roof_pitch_name = const_var.b_r_p_l_to_a[params.b_l_t_r_pB].roof_pitch;
					b.roof_pitch_custom_name = const_var.b_r_p_l_to_a[params.b_l_t_r_pB]?.custom_name;
					b.roof_pitch_price = utlis.convertToTwoDecimalNumber(finalCertPrice);
					t_c_b = parseFloat(t_c_b) + parseFloat(finalCertPrice);
				} else {
					var finalCertPrice =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.back_lean_roof_pitch_price_changed != true
							? backLeanData.roof_pitch_price
							: const_var.b_r_p_l_to_a[params.b_l_t_r_pB]
								? const_var.b_r_p_l_to_a[params.b_l_t_r_pB].cost
								: 0;
					t_c_b = parseFloat(t_c_b) + parseFloat(finalCertPrice);
					b.roof_pitch = const_var.b_r_p_l_to_a[params.b_l_t_r_pB].roof_pitch;
					b.roof_pitch_name = const_var.b_r_p_l_to_a[params.b_l_t_r_pB].roof_pitch;
					b.roof_pitch_custom_name = const_var.b_r_p_l_to_a[params.b_l_t_r_pB]?.custom_name;
					b.roof_pitch_price = utlis.convertToTwoDecimalNumber(finalCertPrice);
				}
			} else {
				b.roof_pitch = "3/12";
				b.roof_pitch_name = "3/12";
				b.roof_pitch_price = 0;
			}
			if (checkBackCertificate) {
			}
			if (params.leanB_p_e_i == "other") {
				b.certificate = { gauge: 0, certified: 1, has_double_leg: 0, has_ladder_leg: 0, has_other_leg: 0, height: 0, id: -1, cost: 0, is_default: "no", length: 0, map_id: 0, name: "Other" };
				b.certificate_other_name = params.leanB_p_e_i_other != "" ? params.leanB_p_e_i_other : "Other";
				b.certificate_price = UpdatePriceRecord == true && const_var.UpdatedPriceData.certificate_price_changed != true ? backLeanData.certificate_price : 0;
			}

			if (params.continous_left_lean == true) {
				b.continous_lean = true;
			} else {
				b.continous_lean = false;
			}
			b.edit_truss_name =
				const_var.c_m_a[params.p_b_t].trussType != undefined && const_var.c_m_a[params.p_b_t].trussType.length > 0 ? params["trussType"] : const_var.c_m_a[params.p_b_t].trussType[0].name.replace(/[0-9]/g, "");

			if (b.leanto_style === "gable") {
				const trussPrice = trussCalcuateForGableLean(params, 0, b, backLeanData, UpdatePriceRecord);
				if (trussPrice > 0) {
					t_c_b += trussPrice;
				}
			}

			b.pricing_data = data;

			b.t_c_b = parseFloat(t_c_b);
			const_var.leanto.push(b);
			const_var.UpdatedPriceData.leanto.push(b);
		} else {
			removeDataFromArray(4);
		}

		cP(const_var.a_p_d_a, true);
	};

	const cPforLLeanOnly = (data = const_var.leanGetDataLeft, objIndex, newDW, options) => {
		const { ConvStr, removeDataFromArray, convertToTwoDecimalNumber, cP, setInsulation, isCustomInsulation } = getRuntimeDeps();
		let t_c_b = 0;

		let b = {};

		const prevLean = JSON.parse(JSON.stringify(const_var.post_data?.building?.leanto?.find((l) => l.leanto_type == 1) ?? {}));

		if (const_var.UpdatedPriceData.leanto == undefined) {
			const_var.UpdatedPriceData.leanto = [];
		}
		let UpdatePriceRecord = false;
		let leftLeanData = "";
		if (params.add_left_lean == true) {
			if (newDW == undefined && const_var.UpdatedPriceData.leanto.length > 0) {
				let FindIndex = const_var.UpdatedPriceData.leanto.filter((data) => data.leanto_type == 1);
				if (FindIndex.length > 0) {
					UpdatePriceRecord = true;
					leftLeanData = FindIndex[0];
				}
			}
			removeDataFromArray(1);
			if (newDW != undefined) {
				const_var.UpdatedPriceData.leanto.push(newDW);
			}
			if (const_var.c_f_aCer[params.p_e_i] != undefined) {
				params.lean_p_e_i = const_var.c_f_aCer[params.p_e_i]?.name;
			} else {
				params.lean_p_e_i = params.p_e_i == "Select" ? "" : params.p_e_i;
			}
			let checkLeftCertificate =
				const_var.c_f_aCer[params.p_e_i] != undefined && params.p_e_i != "" && params.p_e_i != "Select" && params.lean_p_e_i != "" && params.lean_p_e_i != "0" && params.lean_p_e_i != "other";
			let newMakeCertificateArrayLeft = const_var.makeCertificateArrayLeft;
			b = {
				leanto_type: 1,
				width: params.lean_p_w,
				height: params.lean_p_h,
				length: params.lean_p_d,
				leanto_drop: "",
				front_wall: ConvStr(params.p_b_c_b_l_f),
				back_wall: ConvStr(params.p_b_c_b_l_b),
				side_wall: ConvStr(params.p_b_c_b_l),
				front_wall_price: 0,
				back_wall_price: 0,
				side_wall_price: 0,
				front_wall_vertical: params.p_v_w,
				back_wall_vertical: params.p_v_w,
				side_wall_vertical: params.p_v_w,
				certificate: newMakeCertificateArrayLeft[params.lean_p_e_i],
				right_wall: ConvStr(params.p_b_c_b_l_r),
				right_wall_price: 0,
				right_wall_vertical: params.p_v_w
			};
			if (const_var.isLTBuilding && params.leanStyle.left == "gable") {
				b.roof_length = params.frame_length;
			}

			var CalCulateRoofBasePrice = 0;
			var CalCulateRoofEndClosePrice = 0;
			var CalCulateRoofEndGablePrice = 0;
			var CalCulateRoofUtilityEndPrice = 0;

			if (params.add_storage_check == true) {
				data.side = data.side;
				data.panel = data.panel;
			} else {
				data.side = data.full_length_side != undefined ? data.full_length_side : data.side;
				data.panel = data.full_length_panel != undefined ? data.full_length_panel : data.panel;
			}

			if (const_var.UpdatedPriceData.leanto.length > 0) {
				let FindIndex = const_var.UpdatedPriceData.leanto.filter((data) => data.leanto_type == 1);

				if (FindIndex.length > 0) {
					UpdatePriceRecord = true;
					leftLeanData = FindIndex[0];
				}
			}

			const leftLeanResult = calculateLeanBasicPrice({
				baseData: data.base,
				gaugeValue: const_var.g_v,
				p_r_s: params.p_r_s,
				UpdatePriceRecord,
				priceChangedFlag: const_var.UpdatedPriceData.left_lean_roof_style_price_changed,
				leanData: leftLeanData,
				currentTotal: t_c_b
			});

			b.basic_price = leftLeanResult.basic_price;
			t_c_b = leftLeanResult.total;
			CalCulateRoofBasePrice = leftLeanResult.roofBasePrice;
			if (params.add_left_front_lean_porch == true) {
				b.porch = { type: "left", length: params.lean_p_d + params.leanF_p_d };
			}
			if (params.add_left_back_lean_porch == true) {
				b.porch = { type: "left", length: params.lean_p_d + params.leanB_p_d };
			}
			if (params.add_left_back_lean_porch == true && params.add_left_front_lean_porch == true) {
				b.porch = { type: "left", length: params.lean_p_d + params.leanB_p_d + params.leanF_p_d };
			}

			let heightFullData = data.full_length_side != undefined && data.full_length_side.length > 0 ? data.full_length_side : undefined;
			b.lean_has_double_leg = params.lean_p_e_l;
			b.legstype = const_var.leanLegstype;
			b.lean_has_double_leg_name = const_var.leanHasDoublelegName;
			b.leanto_style = params.leanStyle.left;

			if (heightFullData?.length > 0) {
				if (const_var.g_v == 14) {
					if (params.lean_p_e_l == true && const_var.leanLegstype != undefined && (const_var.leanLegstype.includes("ladder") || const_var.leanLegstype.includes("zigzag"))) {
						b.height_price =
							UpdatePriceRecord == true && const_var.UpdatedPriceData.left_lean_height_price_changed != true
								? leftLeanData.height_price
								: heightFullData[0].ladder_cost != undefined && heightFullData[0].ladder_cost != 0
									? heightFullData[0].ladder_cost
									: heightFullData[0].double_leg_baserail_cost != 0
										? heightFullData[0].double_leg_baserail_cost
										: heightFullData[0].leg_height_cost;
						t_c_b = parseFloat(t_c_b) + parseFloat(b.height_price);
					} else if (
						heightFullData[0]?.double_leg_baserail_cost &&
						heightFullData[0]?.double_leg_baserail_cost != 0 &&
						params.lean_p_e_l == true &&
						const_var.leanLegstype != undefined &&
						const_var.leanLegstype.includes("double")
					) {
						b.height_price =
							UpdatePriceRecord == true && const_var.UpdatedPriceData.left_lean_height_price_changed != true
								? leftLeanData.height_price
								: heightFullData[0].double_leg_baserail_cost != 0
									? heightFullData[0].double_leg_baserail_cost
									: heightFullData[0].leg_height_cost;
						t_c_b = parseFloat(t_c_b) + parseFloat(b.height_price);
					} else {
						b.height_price = UpdatePriceRecord == true && const_var.UpdatedPriceData.left_lean_height_price_changed != true ? leftLeanData.height_price : heightFullData[0].leg_height_cost;
						t_c_b = parseFloat(t_c_b) + parseFloat(b.height_price);
					}
				}
				if (const_var.g_v == 12) {
					if (params.lean_p_e_l == true) {
						if (params.lean_p_e_l == true && const_var.leanLegstype != undefined && (const_var.leanLegstype.includes("ladder") || const_var.leanLegstype.includes("zigzag"))) {
							b.height_price =
								UpdatePriceRecord == true && const_var.UpdatedPriceData.left_lean_height_price_changed != true
									? leftLeanData.height_price
									: heightFullData[0].ladder_cost != undefined && heightFullData[0].ladder_cost != 0
										? heightFullData[0].ladder_cost
										: heightFullData[0].leg_height_cost_12 != 0
											? heightFullData[0].leg_height_cost_12
											: heightFullData[0].leg_height_cost;
							t_c_b = parseFloat(t_c_b) + parseFloat(b.height_price);
						} else if (
							heightFullData[0].double_leg_baserail_cost_12 == 0 &&
							heightFullData[0].double_leg_baserail_cost == 0 &&
							const_var.leanLegstype != undefined &&
							const_var.leanLegstype.includes("double")
						) {
							b.height_price =
								UpdatePriceRecord == true && const_var.UpdatedPriceData.left_lean_height_price_changed != true
									? leftLeanData.height_price
									: heightFullData[0].leg_height_cost_12 != 0
										? heightFullData[0].leg_height_cost_12
										: heightFullData[0].leg_height_cost;
							t_c_b = parseFloat(t_c_b) + parseFloat(b.height_price);
						} else {
							b.height_price =
								UpdatePriceRecord == true && const_var.UpdatedPriceData.left_lean_height_price_changed != true
									? leftLeanData.height_price
									: heightFullData[0].double_leg_baserail_cost_12 != 0
										? heightFullData[0].double_leg_baserail_cost_12
										: heightFullData[0].double_leg_baserail_cost;
							t_c_b = parseFloat(t_c_b) + parseFloat(b.height_price);
						}
					} else {
						b.height_price =
							UpdatePriceRecord == true && const_var.UpdatedPriceData.left_lean_height_price_changed != true
								? leftLeanData.height_price
								: heightFullData[0].leg_height_cost_12 != 0
									? heightFullData[0].leg_height_cost_12
									: heightFullData[0].leg_height_cost;
						t_c_b = parseFloat(t_c_b) + parseFloat(b.height_price);
					}
				}
			}

			let editCheckForHeritage =
				const_var.crmSetting.is_Edit == true &&
				params.m_s_n == 153 &&
				(params.p_r_s == 1 || params.p_r_s == 2) &&
				const_var.editAPIDataByResponse != undefined &&
				const_var.editAPIDataByResponse.data != undefined;

			let heritageNoInsulationCaseLeftLean = heritageNoInsulation(params, editCheckForHeritage, false, "leftLean");

			if (params.insulation.leftLean.insulationId == 0 && params.p_i_o != 0 && (params.p_f_i || params.p_r_o) && const_var.leanGetDataLeft.insulation != undefined) {
				params.insulation.leftLean.insulationId = params.p_i_o;
			}

			if (params.insulation.leftLean.insulationId != 0 && heritageNoInsulationCaseLeftLean != true) {
				if (params.add_left_lean && data != "" && const_var.insulationArrayForLeantoLeft && const_var.insulationArrayForLeantoLeft[params.insulation.leftLean.insulationId] != undefined) {
					if (const_var.leanGetDataLeft.insulation != undefined && isCustomInsulation("left")) {
						if (leftLeanData?.insulation_type?.insulation_wall) {
							const_var.insulationArrayForLeantoLeft.insulation_wall = leftLeanData.insulation_type.insulation_wall;
						}

						calcInsulationPrice();

						b.insulation_price = UpdatePriceRecord && const_var.UpdatedPriceData.left_lean_insulation_price_changed != true ? leftLeanData.insulation_price : const_var.LLInsulationPrice;
						b.insulation_type = const_var.insulationArrayForLeantoLeft[params.insulation.leftLean.insulationId];

						b.insulation_type.insulation_wall = const_var.insulationArrayForLeantoLeft.insulation_wall;

						let chkForInsulationPrice = commonFunctionForInsulationCalculations(b.insulation_price, params.insulation.leftLean.insulationId);
						if (chkForInsulationPrice != true) {
							t_c_b = parseFloat(t_c_b) + parseFloat(b.insulation_price);
						}
					} else {
						let insulationId = params.p_i_o,
							p_f_i = params.p_f_i,
							p_r_o = params.p_r_o;

						const insulationRes = calculateInsulation(
							const_var.insulationArrayForLeantoLeft[insulationId],
							p_f_i,
							p_r_o,
							"leftLean",
							params.add_storage_check,
							params.p_b_c_b_l,
							params.p_b_c_b_l_f,
							params.p_b_c_b_l_b,
							params.p_b_c_b_l_r,
							"left"
						);
						b.insulation = insulationRes.insulation;
						b.insulation_price =
							UpdatePriceRecord && const_var.UpdatedPriceData.left_lean_insulation_price_changed != true ? leftLeanData.insulation_price : convertToTwoDecimalNumber(insulationRes.insulationPrice);
						b.insulation_type = const_var.insulationArrayForLeantoLeft[params.insulation.leftLean.insulationId];
						if (leftLeanData?.insulation_type?.insulation_wall) {
							const_var.insulationArrayForLeantoLeft.insulation_wall = leftLeanData.insulation_type.insulation_wall;
						}
						b.insulation_type.insulation_wall = const_var.insulationArrayForLeantoLeft.insulation_wall;
					}
				}
			} else {
				b.insulation_price = 0;
			}
			setInsulation(b);
			if (data?.gable_end[0]) {
				if (params.p_b_c_b_l_f == "Gable") {
					var ShowPrice = "";
					if (params.p_v_w == true) {
						if (params.lean_p_e_i != "" && params.lean_p_e_i != "other" && params.lean_p_e_i != "0" && newMakeCertificateArrayLeft?.[params.lean_p_e_i]?.certified == 1) {
							ShowPrice =
								UpdatePriceRecord == true && const_var.UpdatedPriceData.left_lean_front_wall_price_changed != true
									? leftLeanData.front_wall_price
									: data.gable_end[0].vertical_certified + data.gable_end[0].certified;
						} else {
							ShowPrice =
								UpdatePriceRecord == true && const_var.UpdatedPriceData.left_lean_front_wall_price_changed != true
									? leftLeanData.front_wall_price
									: data.gable_end[0].uncertified + data.gable_end[0].vertical;
						}
					} else {
						if (params.lean_p_e_i != "" && params.lean_p_e_i != "other" && params.lean_p_e_i != "0" && newMakeCertificateArrayLeft?.[params.lean_p_e_i]?.certified == 1) {
							ShowPrice = UpdatePriceRecord == true && const_var.UpdatedPriceData.left_lean_front_wall_price_changed != true ? leftLeanData.front_wall_price : data.gable_end[0].certified;
						} else {
							ShowPrice = UpdatePriceRecord == true && const_var.UpdatedPriceData.left_lean_front_wall_price_changed != true ? leftLeanData.front_wall_price : data.gable_end[0].uncertified;
						}
					}
					b.front_wall_price = ShowPrice;
					t_c_b = parseFloat(t_c_b) + parseFloat(b.front_wall_price);
					CalCulateRoofEndGablePrice = b.front_wall_price;
				}
				if (params.p_b_c_b_l_b == "Gable") {
					var ShowPrice = "";
					if (params.p_v_w == true) {
						if (params.lean_p_e_i != "" && params.lean_p_e_i != "other" && params.lean_p_e_i != "0" && newMakeCertificateArrayLeft?.[params.lean_p_e_i]?.certified == 1) {
							ShowPrice =
								UpdatePriceRecord == true && const_var.UpdatedPriceData.left_lean_back_wall_price_changed != true
									? leftLeanData.back_wall_price
									: data.gable_end[0].vertical_certified + data.gable_end[0].certified;
						} else {
							ShowPrice =
								UpdatePriceRecord == true && const_var.UpdatedPriceData.left_lean_back_wall_price_changed != true
									? leftLeanData.back_wall_price
									: data.gable_end[0].uncertified + data.gable_end[0].vertical;
						}
					} else {
						if (params.lean_p_e_i != "" && params.lean_p_e_i != "other" && params.lean_p_e_i != "0" && newMakeCertificateArrayLeft?.[params.lean_p_e_i]?.certified == 1) {
							ShowPrice = UpdatePriceRecord == true && const_var.UpdatedPriceData.left_lean_back_wall_price_changed != true ? leftLeanData.back_wall_price : data.gable_end[0].certified;
						} else {
							ShowPrice = UpdatePriceRecord == true && const_var.UpdatedPriceData.left_lean_back_wall_price_changed != true ? leftLeanData.back_wall_price : data.gable_end[0].uncertified;
						}
					}
					b.back_wall_price = ShowPrice;
					t_c_b = parseFloat(t_c_b) + parseFloat(b.back_wall_price);
					CalCulateRoofEndGablePrice = CalCulateRoofEndGablePrice + b.back_wall_price;
				}
			}
			if (data?.end[0]) {
				if (params.p_b_c_b_l_f == "Half_Close") {
					b.front_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.left_lean_front_wall_price_changed != true
							? leftLeanData.front_wall_price
							: params.p_v_w == true
								? (data.end[0].half_vertical_ends_cost + data.end[0].half_end_close_cost).toFixed(2)
								: data.end[0].half_end_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.front_wall_price);
				}
				if (params.p_b_c_b_l_f == "One_Fourth_Close") {
					b.front_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.left_lean_front_wall_price_changed != true
							? leftLeanData.front_wall_price
							: params.p_v_w == true
								? (data.end[0].one_fourth_vertical_ends_cost + data.end[0].one_fourth_end_close_cost).toFixed(2)
								: data.end[0].one_fourth_end_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.front_wall_price);
				}
				if (params.p_b_c_b_l_f == "Three_Fourth_Close") {
					b.front_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.left_lean_front_wall_price_changed != true
							? leftLeanData.front_wall_price
							: params.p_v_w == true
								? (data.end[0].three_fourth_vertical_ends_cost + data.end[0].three_fourth_end_close_cost).toFixed(2)
								: data.end[0].three_fourth_end_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.front_wall_price);
				}

				if (params.p_b_c_b_l_f == "Close") {
					b.front_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.left_lean_front_wall_price_changed != true
							? leftLeanData.front_wall_price
							: params.p_v_w == true
								? convertToTwoDecimalNumber(data.end[0].vertical_ends_cost + data.end[0].end_close_cost)
								: data.end[0].end_close_cost;
					t_c_b = parseFloat(t_c_b) + parseFloat(b.front_wall_price);
					CalCulateRoofEndClosePrice = b.front_wall_price;
				}
				if (params.p_b_c_b_l_f == "Half End" || params.p_b_c_b_l_f == "Half Dutch End") {
					let dutchPrice = 0;
					if (data.garage_door_frameout != undefined && params.p_b_c_b_l_f == "Half Dutch End") {
						dutchPrice = data.garage_door_frameout[0].dutch_cost;
					}
					b.front_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.left_lean_front_wall_price_changed != true
							? leftLeanData.front_wall_price
							: params.p_v_w == true
								? convertToTwoDecimalNumber(data.end[0].vertical_ends_cost / 2 + data.end[0].end_close_cost / 2 + dutchPrice)
								: utlis.convertToTwoDecimalNumber(data.end[0].end_close_cost / 2 + dutchPrice);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.front_wall_price);
					CalCulateRoofEndClosePrice = parseFloat(CalCulateRoofEndClosePrice) + parseFloat(b.front_wall_price);
				}

				if (params.p_b_c_b_l_b == "Half End" || params.p_b_c_b_l_b == "Half Dutch End") {
					let dutchPrice = 0;
					if (data.garage_door_frameout != undefined && params.p_b_c_b_l_b == "Half Dutch End") {
						dutchPrice = data.garage_door_frameout[0].dutch_cost;
					}
					b.back_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.left_lean_back_wall_price_changed != true
							? leftLeanData.back_wall_price
							: params.p_v_w == true
								? convertToTwoDecimalNumber(data.end[0].vertical_ends_cost / 2 + data.end[0].end_close_cost / 2 + dutchPrice)
								: convertToTwoDecimalNumber(data.end[0].end_close_cost / 2 + dutchPrice);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.back_wall_price);
					CalCulateRoofEndClosePrice = parseFloat(CalCulateRoofEndClosePrice) + parseFloat(b.back_wall_price);
				}
				if (params.p_b_c_b_l_b == "Half_Close") {
					b.back_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.left_lean_back_wall_price_changed != true
							? leftLeanData.back_wall_price
							: params.p_v_w == true
								? (data.end[0].half_vertical_ends_cost + data.end[0].half_end_close_cost).toFixed(2)
								: data.end[0].half_end_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.back_wall_price);
				}
				if (params.p_b_c_b_l_b == "One_Fourth_Close") {
					b.back_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.left_lean_back_wall_price_changed != true
							? leftLeanData.back_wall_price
							: params.p_v_w == true
								? (data.end[0].one_fourth_vertical_ends_cost + data.end[0].one_fourth_end_close_cost).toFixed(2)
								: data.end[0].one_fourth_end_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.back_wall_price);
				}
				if (params.p_b_c_b_l_b == "Three_Fourth_Close") {
					b.back_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.left_lean_back_wall_price_changed != true
							? leftLeanData.back_wall_price
							: params.p_v_w == true
								? (data.end[0].three_fourth_vertical_ends_cost + data.end[0].three_fourth_end_close_cost).toFixed(2)
								: data.end[0].three_fourth_end_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.back_wall_price);
				}
				if (params.p_b_c_b_l_b == "Close") {
					b.back_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.left_lean_back_wall_price_changed != true
							? leftLeanData.back_wall_price
							: params.p_v_w == true
								? convertToTwoDecimalNumber(data.end[0].vertical_ends_cost + data.end[0].end_close_cost)
								: data.end[0].end_close_cost;
					t_c_b = parseFloat(t_c_b) + parseFloat(b.back_wall_price);
					CalCulateRoofEndClosePrice = CalCulateRoofEndClosePrice + b.back_wall_price;
				}
			}
			if (data?.side[0]) {
				if (params.p_b_c_b_l == "Close") {
					b.side_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.left_lean_left_wall_price_changed != true
							? leftLeanData.side_wall_price
							: params.p_v_w == true
								? convertToTwoDecimalNumber(data.side[0].vertical_side_cost + data.side[0].side_close_cost)
								: data.side[0].side_close_cost;
					t_c_b = parseFloat(t_c_b) + parseFloat(b.side_wall_price);
				}
				if (params.p_b_c_b_l == "Half_Close") {
					b.side_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.left_lean_left_wall_price_changed != true
							? leftLeanData.side_wall_price
							: params.p_v_w == true
								? (data.side[0].half_vertical_side_cost + data.side[0].half_side_close_cost).toFixed(2)
								: data.side[0].half_side_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.side_wall_price);
				}
				if (params.p_b_c_b_l == "One_Fourth_Close") {
					b.side_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.left_lean_left_wall_price_changed != true
							? leftLeanData.side_wall_price
							: params.p_v_w == true
								? (data.side[0].one_fourth_vertical_side_cost + data.side[0].one_fourth_side_close_cost).toFixed(2)
								: data.side[0].one_fourth_side_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.side_wall_price);
				}
				if (params.p_b_c_b_l == "Three_Fourth_Close") {
					b.side_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.left_lean_left_wall_price_changed != true
							? leftLeanData.side_wall_price
							: params.p_v_w == true
								? (data.side[0].three_fourth_vertical_side_cost + data.side[0].three_fourth_side_close_cost).toFixed(2)
								: data.side[0].three_fourth_side_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.side_wall_price);
				}
			}
			if (data?.panel[0]) {
				if (params.p_b_c_b_l !== "Close" && params.p_b_c_b_l !== "Open" && params.p_b_c_b_l != "Half_Close" && params.p_b_c_b_l != "One_Fourth_Close" && params.p_b_c_b_l != "Three_Fourth_Close") {
					b.side_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.left_lean_left_wall_price_changed != true
							? leftLeanData.side_wall_price
							: params.p_v_w == true
								? data.panel[0].vertical_panel_cost * params.p_b_c_b_l
								: data.panel[0].cost * params.p_b_c_b_l;
					t_c_b = parseFloat(t_c_b) + parseFloat(b.side_wall_price);
				}
			}
			if (const_var.isLTBuilding) {
				if (params.p_b_c_b_l_r == "Close") {
					b.right_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.left_lean_right_wall_price_changed != true
							? leftLeanData.right_wall_price
							: params.p_v_w == true
								? convertToTwoDecimalNumber(data.side[0].vertical_side_cost + data.side[0].side_close_cost)
								: data.side[0].side_close_cost;
					t_c_b = parseFloat(t_c_b) + parseFloat(b.right_wall_price);
				}
				if (params.p_b_c_b_l_r == "Half_Close") {
					b.right_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.left_lean_right_wall_price_changed != true
							? leftLeanData.right_wall_price
							: params.p_v_w == true
								? (data.side[0].half_vertical_side_cost + data.side[0].half_side_close_cost).toFixed(2)
								: data.side[0].half_side_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.right_wall_price);
				}
				if (params.p_b_c_b_l_r == "One_Fourth_Close") {
					b.right_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.left_lean_right_wall_price_changed != true
							? leftLeanData.right_wall_price
							: params.p_v_w == true
								? (data.side[0].one_fourth_vertical_side_cost + data.side[0].one_fourth_side_close_cost).toFixed(2)
								: data.side[0].one_fourth_side_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.right_wall_price);
				}
				if (params.p_b_c_b_l_r == "Three_Fourth_Close") {
					b.right_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.left_lean_right_wall_price_changed != true
							? leftLeanData.right_wall_price
							: params.p_v_w == true
								? (data.side[0].three_fourth_vertical_side_cost + data.side[0].three_fourth_side_close_cost).toFixed(2)
								: data.side[0].three_fourth_side_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.right_wall_price);
				}
				if (params.p_b_c_b_l_r !== "Close" && params.p_b_c_b_l_r !== "Open" && params.p_b_c_b_l_r != "Half_Close" && params.p_b_c_b_l_r != "One_Fourth_Close" && params.p_b_c_b_l_r != "Three_Fourth_Close") {
					b.right_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.left_lean_right_wall_price_changed != true
							? leftLeanData.right_wall_price
							: params.p_v_w == true
								? data.panel[0].vertical_panel_cost * params.p_b_c_b_l_r
								: data.panel[0].cost * params.p_b_c_b_l_r;
					t_c_b = parseFloat(t_c_b) + parseFloat(b.right_wall_price);
				}
			}
			//  Left Lean utility calculation
			({ t_c_b, CalCulateRoofUtilityEndPrice } = handleLeanUtility({
				checkFlag: "add_storage_check",
				storageKey: "add_storage",
				positionKey: "leftLeanStoragePosition",
				depthKey: "lean_p_d",
				sideCloseKey1: "p_b_c_b_l",
				sideCloseKey2: "p_b_c_b_l_r",
				wallKey: "p_l_w",
				positionConditionType: "neq",
				leanStyleKey: "left",
				leanData: leftLeanData,
				updatedFlagKey: "left_lean_utility_price_changed",
				data,
				b,
				t_c_b,
				UpdatePriceRecord,
				params, // ✅ ADD THIS
				const_var
			}));
			if (const_var.b_r_p_l_to_a.length > 0 && const_var.b_r_p_l_to_a[params.b_l_t_r_p] != undefined) {
				if (const_var.b_r_p_l_to_a[params.b_l_t_r_p].cost_type == "%") {
					var splitVal =
						const_var.b_r_p_l_to_a[params.b_l_t_r_p].percentage_of != undefined && const_var.b_r_p_l_to_a[params.b_l_t_r_p].percentage_of != 0
							? const_var.b_r_p_l_to_a[params.b_l_t_r_p].percentage_of.split(",")
							: 0;
					var splval = 0;
					if (splitVal != 0) {
						if (splitVal.includes("1") != false) {
							splval = splval + CalCulateRoofBasePrice;
						}
						if (splitVal.includes("2") != false) {
							if (CalCulateRoofUtilityEndPrice != 0) {
								splval = parseFloat(splval) + parseFloat(CalCulateRoofUtilityEndPrice);
							}
							splval = parseFloat(splval) + parseFloat(CalCulateRoofEndClosePrice);
						}
						if (splitVal.includes("3") != false) {
							splval = splval + CalCulateRoofUtilityEndPrice;
						}
					} else {
						splval = splval + CalCulateRoofBasePrice;
					}
					let finalCertPrice =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.left_lean_roof_pitch_price_changed != true
							? leftLeanData.roof_pitch_price
							: const_var.b_r_p_l_to_a[params.b_l_t_r_p]
								? (splval * const_var.b_r_p_l_to_a[params.b_l_t_r_p].cost) / 100
								: 0;
					b.roof_pitch = const_var.b_r_p_l_to_a[params.b_l_t_r_p].roof_pitch;
					b.roof_pitch_name = const_var.b_r_p_l_to_a[params.b_l_t_r_p].roof_pitch;
					b.roof_pitch_custom_name = const_var.b_r_p_l_to_a[params.b_l_t_r_p]?.custom_name;
					b.roof_pitch_price = utlis.convertToTwoDecimalNumber(finalCertPrice);
					t_c_b = parseFloat(t_c_b) + parseFloat(finalCertPrice);
				} else {
					let finalCertPrice =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.left_lean_roof_pitch_price_changed != true
							? leftLeanData.roof_pitch_price
							: const_var.b_r_p_l_to_a[params.b_l_t_r_p]
								? const_var.b_r_p_l_to_a[params.b_l_t_r_p].cost
								: 0;
					t_c_b = parseFloat(t_c_b) + parseFloat(finalCertPrice);
					b.roof_pitch = const_var.b_r_p_l_to_a[params.b_l_t_r_p].roof_pitch;
					b.roof_pitch_name = const_var.b_r_p_l_to_a[params.b_l_t_r_p].roof_pitch;
					b.roof_pitch_custom_name = const_var.b_r_p_l_to_a[params.b_l_t_r_p]?.custom_name;
					b.roof_pitch_price = utlis.convertToTwoDecimalNumber(finalCertPrice);
				}
			} else {
				b.roof_pitch = "3/12";
				b.roof_pitch_name = "3/12";
				b.roof_pitch_price = 0;
			}
			if (checkLeftCertificate) {
				if (params.p_i_s == "1") {
				} else {
					if (newMakeCertificateArrayLeft?.[params.lean_p_e_i]?.percentage_of_cost != 0) {
					} else {
						let finalCertPrice =
							UpdatePriceRecord == true && const_var.UpdatedPriceData.certificate_price_changed != true ? leftLeanData.certificate_price : (newMakeCertificateArrayLeft?.[params.lean_p_e_i]?.cost ?? 0);
						b.certificate_price = finalCertPrice;
					}
				}
			}
			if (params.lean_p_e_i == "other") {
				b.certificate = { gauge: 0, certified: 1, has_double_leg: 0, has_ladder_leg: 0, has_other_leg: 0, height: 0, id: -1, cost: 0, is_default: "no", length: 0, map_id: 0, name: "Other" };
				b.certificate_other_name = params.lean_p_e_i_other != "" ? params.lean_p_e_i_other : "Other";
				b.certificate_price = UpdatePriceRecord == true && const_var.UpdatedPriceData.certificate_price_changed != true ? leftLeanData.certificate_price : 0;
			}

			if (params.continous_left_lean == true) {
				b.continous_lean = true;
			} else {
				b.continous_lean = false;
			}
			b.edit_truss_name =
				const_var.c_m_a[params.p_b_t].trussType != undefined && const_var.c_m_a[params.p_b_t].trussType.length > 0 ? params["trussType"] : const_var.c_m_a[params.p_b_t].trussType[0].name.replace(/[0-9]/g, "");
			if (b.leanto_style === "gable") {
				const trussPrice = trussCalcuateForGableLean(params, 0, b, leftLeanData, UpdatePriceRecord);
				if (trussPrice > 0) {
					t_c_b += trussPrice;
				}
			}
			b.pricing_data = data;
			b.t_c_b = parseFloat(t_c_b);
			const_var.leanto.push(b);
			const_var.UpdatedPriceData.leanto.push(b);
		} else {
			removeDataFromArray(1);
		}
		cP(const_var.a_p_d_a, true);
	};

	const cPforRLeanOnly = (data = const_var.leanGetDataRight, objIndex, newDW, options) => {
		const { ConvStr, removeDataFromArray, convertToTwoDecimalNumber, cP, setInsulation, calcOverhangSize, commonFunctionForColor, isCustomInsulation } = getRuntimeDeps();
		let activeLean;
		let t_c;
		let t_c_b = 0;

		const prevLean = JSON.parse(JSON.stringify(const_var.post_data?.building?.leanto?.find((l) => l.leanto_type == 2) ?? {}));

		if (const_var.UpdatedPriceData.leanto == undefined) {
			const_var.UpdatedPriceData.leanto = [];
		}
		let UpdatePriceRecord = false;
		let rightLeanData = "";
		if (params.add_right_lean == true) {
			if (newDW == undefined && const_var.UpdatedPriceData.leanto.length > 0) {
				let FindIndex = const_var.UpdatedPriceData.leanto.filter((data) => data.leanto_type == 2);
				if (FindIndex.length > 0) {
					UpdatePriceRecord = true;
					rightLeanData = FindIndex[0];
				}
			}
			removeDataFromArray(2);
			if (newDW != undefined) {
				const_var.UpdatedPriceData.leanto.push(newDW);
			}
			if (const_var.c_f_aCer[params.p_e_i] != undefined) {
				params.leanR_p_e_i = const_var.c_f_aCer[params.p_e_i]?.name;
			} else {
				params.leanR_p_e_i = params.p_e_i == "Select" ? "" : params.p_e_i;
			}
			if (const_var.UpdatedPriceData.leanto.length > 0) {
				let FindIndex = const_var.UpdatedPriceData.leanto.filter((data) => data.leanto_type == 2);
				if (FindIndex.length > 0) {
					UpdatePriceRecord = true;
					rightLeanData = FindIndex[0];
				}
			}
			let checkRightCertificate =
				const_var.c_f_aCer[params.p_e_i] != undefined && params.p_e_i != "" && params.p_e_i != "Select" && params.leanR_p_e_i != "" && params.leanR_p_e_i != "0" && params.leanR_p_e_i != "other";
			let newMakeCertificateArrayRight = const_var.makeCertificateArrayRight;

			let b = {
				leanto_type: 2,
				width: params.leanR_p_w,
				height: params.leanR_p_h,
				length: params.leanR_p_d,
				leanto_drop: "",
				front_wall: ConvStr(params.p_b_c_b_r_f),
				back_wall: ConvStr(params.p_b_c_b_r_b),
				side_wall: ConvStr(params.p_b_c_b_r),
				front_wall_price: 0,
				back_wall_price: 0,
				side_wall_price: 0,
				front_wall_vertical: params.p_v_w,
				back_wall_vertical: params.p_v_w,
				side_wall_vertical: params.p_v_w,
				certificate: newMakeCertificateArrayRight[params.leanR_p_e_i],
				right_wall: ConvStr(params.p_b_c_b_r_r),
				right_wall_price: 0,
				right_wall_vertical: params.p_v_w
			};
			//a.concat(b);
			if (const_var.isLTBuilding && params.leanStyle.right == "gable") {
				b.roof_length = params.frame_length;
			}

			let mapVal = const_var.map[params.p_r_s];
			let CalCulateRoofBasePrice = 0;
			let CalCulateRoofEndClosePrice = 0;
			let CalCulateRoofEndGablePrice = 0;
			let CalCulateRoofUtilityEndPrice = 0;
			if (params.add_storage_check_right == true) {
				data.side = data.side;
				data.panel = data.panel;
			} else {
				data.side = data.full_length_side != undefined ? data.full_length_side : data.side;
				data.panel = data.full_length_panel != undefined ? data.full_length_panel : data.panel;
			}

			const leftLeanResult = calculateLeanBasicPrice({
				baseData: data.base,
				gaugeValue: const_var.g_v,
				p_r_s: params.p_r_s,
				UpdatePriceRecord,
				priceChangedFlag: const_var.UpdatedPriceData.right_lean_roof_style_price_changed,
				leanData: rightLeanData,
				currentTotal: t_c_b
			});

			b.basic_price = leftLeanResult.basic_price;
			t_c_b = leftLeanResult.total;
			CalCulateRoofBasePrice = leftLeanResult.roofBasePrice;
			if (params.add_right_front_lean_porch == true) {
				b.porch = { type: "right", length: params.leanR_p_d + params.leanF_p_d };
			}
			if (params.add_right_back_lean_porch == true) {
				b.porch = { type: "right", length: params.leanR_p_d + params.leanB_p_d };
			}
			if (params.add_right_back_lean_porch == true && params.add_right_front_lean_porch == true) {
				b.porch = { type: "right", length: params.leanR_p_d + params.leanB_p_d + params.leanF_p_d };
			}

			let heightFullData = data.full_length_side != undefined && data.full_length_side.length > 0 ? data.full_length_side : undefined;
			b.lean_has_double_leg = params.leanR_p_e_l;
			b.lean_has_double_leg_name = const_var.leanRHasDoublelegName;
			b.legstype = const_var.leanRLegstype;
			b.leanto_style = params.leanStyle.right;
			if (heightFullData?.length > 0) {
				if (const_var.g_v == 14) {
					if (params.leanR_p_e_l == true && const_var.leanRLegstype !== undefined && (const_var.leanRLegstype.includes("ladder") || const_var.leanRLegstype.includes("zigzag"))) {
						b.height_price =
							UpdatePriceRecord == true && const_var.UpdatedPriceData.right_lean_height_price_changed != true
								? rightLeanData.height_price
								: heightFullData[0].ladder_cost != undefined && heightFullData[0].ladder_cost != 0
									? heightFullData[0].ladder_cost
									: heightFullData[0].double_leg_baserail_cost != 0
										? heightFullData[0].double_leg_baserail_cost
										: heightFullData[0].leg_height_cost;
						t_c_b = parseFloat(t_c_b) + parseFloat(b.height_price);
						// b.leanR_has_double_leg_price = b.height_price;
					} else if (heightFullData?.[0].double_leg_baserail_cost != 0 && params.leanR_p_e_l == true && const_var.leanRLegstype !== undefined && const_var.leanRLegstype.includes("double")) {
						b.height_price =
							UpdatePriceRecord == true && const_var.UpdatedPriceData.right_lean_height_price_changed != true
								? rightLeanData.height_price
								: heightFullData[0].double_leg_baserail_cost != 0
									? heightFullData[0].double_leg_baserail_cost
									: heightFullData[0].leg_height_cost;
						t_c_b = parseFloat(t_c_b) + parseFloat(b.height_price);
						// b.leanR_has_double_leg_price = b.height_price;
					} else {
						b.height_price = UpdatePriceRecord == true && const_var.UpdatedPriceData.right_lean_height_price_changed != true ? rightLeanData.height_price : heightFullData[0]?.leg_height_cost;
						t_c_b = parseFloat(t_c_b) + parseFloat(b.height_price);
					}
				}
				if (const_var.g_v == 12) {
					if (params.leanR_p_e_l == true) {
						if (const_var.leanRLegstype !== undefined && (const_var.leanRLegstype.includes("ladder") || const_var.leanRLegstype.includes("zigzag"))) {
							b.height_price =
								UpdatePriceRecord == true && const_var.UpdatedPriceData.right_lean_height_price_changed != true
									? rightLeanData.height_price
									: heightFullData[0].ladder_cost != undefined && heightFullData[0].ladder_cost != 0
										? heightFullData[0].ladder_cost
										: heightFullData[0].leg_height_cost_12 != 0
											? heightFullData[0].leg_height_cost_12
											: heightFullData[0].leg_height_cost;
							t_c_b = parseFloat(t_c_b) + parseFloat(b.height_price);
						} else if (
							heightFullData[0].double_leg_baserail_cost_12 == 0 &&
							heightFullData[0].double_leg_baserail_cost == 0 &&
							const_var.leanRLegstype !== undefined &&
							const_var.leanRLegstype.includes("double")
						) {
							b.height_price =
								UpdatePriceRecord == true && const_var.UpdatedPriceData.right_lean_height_price_changed != true
									? rightLeanData.height_price
									: heightFullData[0].leg_height_cost_12 != 0
										? heightFullData[0].leg_height_cost_12
										: heightFullData[0].leg_height_cost;
							t_c_b = parseFloat(t_c_b) + parseFloat(b.height_price);
						} else {
							b.height_price =
								UpdatePriceRecord == true && const_var.UpdatedPriceData.right_lean_height_price_changed != true
									? rightLeanData.height_price
									: heightFullData[0].double_leg_baserail_cost_12 != 0
										? heightFullData[0].double_leg_baserail_cost_12
										: heightFullData[0].double_leg_baserail_cost;
							t_c_b = parseFloat(t_c_b) + parseFloat(b.height_price);
						}
					} else {
						b.height_price =
							UpdatePriceRecord == true && const_var.UpdatedPriceData.right_lean_height_price_changed != true
								? rightLeanData.height_price
								: heightFullData[0].leg_height_cost_12 != 0
									? heightFullData[0].leg_height_cost_12
									: heightFullData[0].leg_height_cost;
						t_c_b = parseFloat(t_c_b) + parseFloat(b.height_price);
					}
				}
			}
			let editCheckForHeritage =
				const_var.crmSetting.is_Edit == true &&
				params.m_s_n == 153 &&
				(params.p_r_s == 1 || params.p_r_s == 2) &&
				const_var.editAPIDataByResponse != undefined &&
				const_var.editAPIDataByResponse.data != undefined;

			let heritageNoInsulationCaseRightLean = heritageNoInsulation(params, editCheckForHeritage, false, "rightLean");

			if (params.insulation.rightLean.insulationId == 0 && params.p_i_o != 0 && (params.p_f_i || params.p_r_o) && const_var.leanGetDataRight.insulation != undefined) {
				params.insulation.rightLean.insulationId = params.p_i_o;
			}
			if (params.insulation.rightLean.insulationId != 0 && heritageNoInsulationCaseRightLean != true) {
				if (params.add_right_lean && const_var.insulationArrayForLeantoRight && const_var.insulationArrayForLeantoRight[params.insulation.rightLean.insulationId] != undefined) {
					if (const_var.leanGetDataRight.insulation != undefined && isCustomInsulation("right")) {
						if (rightLeanData?.insulation_type?.insulation_wall) {
							const_var.insulationArrayForLeantoRight.insulation_wall = rightLeanData.insulation_type.insulation_wall;
						}
						calcInsulationPrice();

						b.insulation_price = UpdatePriceRecord && const_var.UpdatedPriceData.right_lean_insulation_price_changed != true ? rightLeanData.insulation_price : const_var.RLInsulationPrice;
						b.insulation_type = const_var.insulationArrayForLeantoRight[params.insulation.rightLean.insulationId];

						b.insulation_type.insulation_wall = const_var.insulationArrayForLeantoRight.insulation_wall;
						let chkForInsulationPrice = commonFunctionForInsulationCalculations(b.insulation_price, params.insulation.rightLean.insulationId);
						if (chkForInsulationPrice != true) {
							t_c_b = parseFloat(t_c_b) + parseFloat(b.insulation_price);
						}
					} else {
						let insulationId = params.p_i_o,
							p_f_i = params.p_f_i,
							p_r_o = params.p_r_o;

						const insulationRes = calculateInsulation(
							const_var.insulationArrayForLeantoRight[insulationId],
							p_f_i,
							p_r_o,
							"rightLean",
							params.add_storage_check_right,
							params.p_b_c_b_r,
							params.p_b_c_b_r_f,
							params.p_b_c_b_r_b,
							params.p_b_c_b_r_r,
							"right"
						);
						b.insulation = insulationRes.insulation;
						b.insulation_price =
							UpdatePriceRecord && const_var.UpdatedPriceData.right_lean_insulation_price_changed != true ? rightLeanData.insulation_price : convertToTwoDecimalNumber(insulationRes.insulationPrice);
						b.insulation_type = const_var.insulationArrayForLeantoRight[params.insulation.rightLean.insulationId];
						if (rightLeanData?.insulation_type?.insulation_wall) {
							const_var.insulationArrayForLeantoRight.insulation_wall = rightLeanData.insulation_type.insulation_wall;
						}
					}
				}
			} else {
				b.insulation_price = 0;
			}

			setInsulation(b);
			if (data?.gable_end[0]) {
				if (params.p_b_c_b_r_f == "Gable") {
					var ShowPrice = "";
					if (params.p_v_w == true) {
						if (params.leanR_p_e_i != "" && params.leanR_p_e_i != "other" && params.leanR_p_e_i != "0" && newMakeCertificateArrayRight?.[params.leanR_p_e_i]?.certified == 1) {
							ShowPrice =
								UpdatePriceRecord == true && const_var.UpdatedPriceData.right_lean_front_wall_price_changed != true
									? rightLeanData.front_wall_price
									: data.gable_end[0].vertical_certified + data.gable_end[0].certified;
						} else {
							ShowPrice =
								UpdatePriceRecord == true && const_var.UpdatedPriceData.right_lean_front_wall_price_changed != true
									? rightLeanData.front_wall_price
									: data.gable_end[0].uncertified + data.gable_end[0].vertical;
						}
					} else {
						if (params.leanR_p_e_i != "" && params.leanR_p_e_i != "other" && params.leanR_p_e_i != "0" && newMakeCertificateArrayRight?.[params.leanR_p_e_i]?.certified == 1) {
							ShowPrice = UpdatePriceRecord == true && const_var.UpdatedPriceData.right_lean_front_wall_price_changed != true ? rightLeanData.front_wall_price : data.gable_end[0].certified;
						} else {
							ShowPrice = UpdatePriceRecord == true && const_var.UpdatedPriceData.right_lean_front_wall_price_changed != true ? rightLeanData.front_wall_price : data.gable_end[0].uncertified;
						}
					}
					b.front_wall_price = ShowPrice;
					t_c_b = parseFloat(t_c_b) + parseFloat(b.front_wall_price);
					CalCulateRoofEndGablePrice = b.front_wall_price;
				}

				if (params.p_b_c_b_r_b == "Gable") {
					var ShowPrice = "";
					if (params.p_v_w == true) {
						if (params.leanR_p_e_i != "" && params.leanR_p_e_i != "other" && params.leanR_p_e_i != "0" && newMakeCertificateArrayRight?.[params.leanR_p_e_i]?.certified == 1) {
							ShowPrice =
								UpdatePriceRecord == true && const_var.UpdatedPriceData.right_lean_back_wall_price_changed != true
									? rightLeanData.back_wall_price
									: data.gable_end[0].vertical_certified + data.gable_end[0].certified;
						} else {
							ShowPrice =
								UpdatePriceRecord == true && const_var.UpdatedPriceData.right_lean_back_wall_price_changed != true
									? rightLeanData.back_wall_price
									: data.gable_end[0].uncertified + data.gable_end[0].vertical;
						}
					} else {
						if (params.leanR_p_e_i != "" && params.leanR_p_e_i != "other" && params.leanR_p_e_i != "0" && newMakeCertificateArrayRight?.[params.leanR_p_e_i]?.certified == 1) {
							ShowPrice = UpdatePriceRecord == true && const_var.UpdatedPriceData.right_lean_back_wall_price_changed != true ? rightLeanData.back_wall_price : data.gable_end[0].certified;
						} else {
							ShowPrice = UpdatePriceRecord == true && const_var.UpdatedPriceData.right_lean_back_wall_price_changed != true ? rightLeanData.back_wall_price : data.gable_end[0].uncertified;
						}
					}

					b.back_wall_price = ShowPrice;
					t_c_b = parseFloat(t_c_b) + parseFloat(b.back_wall_price);
					CalCulateRoofEndGablePrice = CalCulateRoofEndGablePrice + b.back_wall_price;
				}
			}
			if (data?.end[0]) {
				if (params.p_b_c_b_r_f == "Close") {
					b.front_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.right_lean_front_wall_price_changed != true
							? rightLeanData.front_wall_price
							: params.p_v_w == true
								? convertToTwoDecimalNumber(data.end[0].vertical_ends_cost + data.end[0].end_close_cost)
								: data.end[0].end_close_cost;
					t_c_b = parseFloat(t_c_b) + parseFloat(b.front_wall_price);
					CalCulateRoofEndClosePrice = b.front_wall_price;
				}
				if (params.p_b_c_b_r_b == "Close") {
					b.back_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.right_lean_back_wall_price_changed != true
							? rightLeanData.back_wall_price
							: params.p_v_w == true
								? convertToTwoDecimalNumber(data.end[0].vertical_ends_cost + data.end[0].end_close_cost)
								: data.end[0].end_close_cost;
					t_c_b = parseFloat(t_c_b) + parseFloat(b.back_wall_price);
					CalCulateRoofEndClosePrice = CalCulateRoofEndClosePrice + b.back_wall_price;
				}

				if (params.p_b_c_b_r_f == "Half_Close") {
					b.front_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.right_lean_front_wall_price_changed != true
							? rightLeanData.front_wall_price
							: params.p_v_w == true
								? (data.end[0].half_vertical_ends_cost + data.end[0].half_end_close_cost).toFixed(2)
								: data.end[0].half_end_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.front_wall_price);
				}
				if (params.p_b_c_b_r_f == "One_Fourth_Close") {
					b.front_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.right_lean_front_wall_price_changed != true
							? rightLeanData.front_wall_price
							: params.p_v_w == true
								? (data.end[0].one_fourth_vertical_ends_cost + data.end[0].one_fourth_end_close_cost).toFixed(2)
								: data.end[0].one_fourth_end_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.front_wall_price);
				}
				if (params.p_b_c_b_r_f == "Three_Fourth_Close") {
					b.front_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.right_lean_front_wall_price_changed != true
							? rightLeanData.front_wall_price
							: params.p_v_w == true
								? (data.end[0].three_fourth_vertical_ends_cost + data.end[0].three_fourth_end_close_cost).toFixed(2)
								: data.end[0].three_fourth_end_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.front_wall_price);
				}

				if (params.p_b_c_b_r_f == "Half End" || params.p_b_c_b_r_f == "Half Dutch End") {
					let dutchPrice = 0;
					if (data.garage_door_frameout != undefined && params.p_b_c_b_r_f == "Half Dutch End") {
						dutchPrice = data.garage_door_frameout[0].dutch_cost;
					}
					b.front_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.right_lean_front_wall_price_changed != true
							? rightLeanData.front_wall_price
							: params.p_v_w == true
								? convertToTwoDecimalNumber(data.end[0].vertical_ends_cost / 2 + data.end[0].end_close_cost / 2 + dutchPrice)
								: utlis.convertToTwoDecimalNumber(data.end[0].end_close_cost / 2 + dutchPrice);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.front_wall_price);
					CalCulateRoofEndClosePrice = parseFloat(CalCulateRoofEndClosePrice) + parseFloat(b.front_wall_price);
				}

				if (params.p_b_c_b_r_b == "Half End" || params.p_b_c_b_r_b == "Half Dutch End") {
					let dutchPrice = 0;
					if (data.garage_door_frameout != undefined && params.p_b_c_b_r_b == "Half Dutch End") {
						dutchPrice = data.garage_door_frameout[0].dutch_cost;
					}
					b.back_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.right_lean_back_wall_price_changed != true
							? rightLeanData.back_wall_price
							: params.p_v_w == true
								? convertToTwoDecimalNumber(data.end[0].vertical_ends_cost / 2 + data.end[0].end_close_cost / 2 + dutchPrice)
								: convertToTwoDecimalNumber(data.end[0].end_close_cost / 2 + dutchPrice);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.back_wall_price);
					CalCulateRoofEndClosePrice = parseFloat(CalCulateRoofEndClosePrice) + parseFloat(b.back_wall_price);
				}

				if (params.p_b_c_b_r_b == "Half_Close") {
					b.back_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.right_lean_back_wall_price_changed != true
							? rightLeanData.back_wall_price
							: params.p_v_w == true
								? (data.end[0].half_vertical_ends_cost + data.end[0].half_end_close_cost).toFixed(2)
								: data.end[0].half_end_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.back_wall_price);
				}
				if (params.p_b_c_b_r_b == "One_Fourth_Close") {
					b.back_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.right_lean_back_wall_price_changed != true
							? rightLeanData.back_wall_price
							: params.p_v_w == true
								? (data.end[0].one_fourth_vertical_ends_cost + data.end[0].one_fourth_end_close_cost).toFixed(2)
								: data.end[0].one_fourth_end_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.back_wall_price);
				}
				if (params.p_b_c_b_r_b == "Three_Fourth_Close") {
					b.back_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.right_lean_back_wall_price_changed != true
							? rightLeanData.back_wall_price
							: params.p_v_w == true
								? (data.end[0].three_fourth_vertical_ends_cost + data.end[0].three_fourth_end_close_cost).toFixed(2)
								: data.end[0].three_fourth_end_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.back_wall_price);
				}
			}
			if (data?.side[0]) {
				if (params.p_b_c_b_r == "Close") {
					b.side_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.right_lean_right_wall_price_changed != true
							? rightLeanData.side_wall_price
							: params.p_v_w == true
								? convertToTwoDecimalNumber(data.side[0].vertical_side_cost + data.side[0].side_close_cost)
								: data.side[0].side_close_cost;

					t_c_b = parseFloat(t_c_b) + parseFloat(b.side_wall_price);
				}

				if (params.p_b_c_b_r == "Half_Close") {
					b.side_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.right_lean_right_wall_price_changed != true
							? rightLeanData.side_wall_price
							: params.p_v_w == true
								? (data.side[0].half_vertical_side_cost + data.side[0].half_side_close_cost).toFixed(2)
								: data.side[0].half_side_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.side_wall_price);
				}
				if (params.p_b_c_b_r == "One_Fourth_Close") {
					b.side_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.right_lean_right_wall_price_changed != true
							? rightLeanData.side_wall_price
							: params.p_v_w == true
								? (data.side[0].one_fourth_vertical_side_cost + data.side[0].one_fourth_side_close_cost).toFixed(2)
								: data.side[0].one_fourth_side_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.side_wall_price);
				}
				if (params.p_b_c_b_r == "Three_Fourth_Close") {
					b.side_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.right_lean_right_wall_price_changed != true
							? rightLeanData.side_wall_price
							: params.p_v_w == true
								? (data.side[0].three_fourth_vertical_side_cost + data.side[0].three_fourth_side_close_cost).toFixed(2)
								: data.side[0].three_fourth_side_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.side_wall_price);
				}
			}
			if (data?.panel[0]) {
				if (params.p_b_c_b_r !== "Close" && params.p_b_c_b_r !== "Open" && params.p_b_c_b_r != "Half_Close" && params.p_b_c_b_r != "One_Fourth_Close" && params.p_b_c_b_r != "Three_Fourth_Close") {
					b.side_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.right_lean_right_wall_price_changed != true
							? rightLeanData.side_wall_price
							: params.p_v_w == true
								? data.panel[0].vertical_panel_cost * params.p_b_c_b_r
								: data.panel[0].cost * params.p_b_c_b_r;
					t_c_b = parseFloat(t_c_b) + parseFloat(b.side_wall_price);
				}
			}
			if (const_var.isLTBuilding) {
				if (params.p_b_c_b_r_r == "Close") {
					b.right_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.right_lean_left_wall_price_changed != true
							? rightLeanData.right_wall_price
							: params.p_v_w == true
								? convertToTwoDecimalNumber(data.side[0].vertical_side_cost + data.side[0].side_close_cost)
								: data.side[0].side_close_cost;

					t_c_b = parseFloat(t_c_b) + parseFloat(b.right_wall_price);
				}
				if (params.p_b_c_b_r_r !== "Close" && params.p_b_c_b_r_r !== "Open" && params.p_b_c_b_r_r != "Half_Close" && params.p_b_c_b_r_r != "One_Fourth_Close" && params.p_b_c_b_r_r != "Three_Fourth_Close") {
					b.right_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.right_lean_left_wall_price_changed != true
							? rightLeanData.right_wall_price
							: params.p_v_w == true
								? data.panel[0].vertical_panel_cost * params.p_b_c_b_r_r
								: data.panel[0].cost * params.p_b_c_b_r_r;
					t_c_b = parseFloat(t_c_b) + parseFloat(b.right_wall_price);
				}
				if (params.p_b_c_b_r_r == "Half_Close") {
					b.right_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.right_lean_left_wall_price_changed != true
							? rightLeanData.right_wall_price
							: params.p_v_w == true
								? (data.side[0].half_vertical_side_cost + data.side[0].half_side_close_cost).toFixed(2)
								: data.side[0].half_side_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.right_wall_price);
				}
				if (params.p_b_c_b_r_r == "One_Fourth_Close") {
					b.right_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.right_lean_left_wall_price_changed != true
							? rightLeanData.right_wall_price
							: params.p_v_w == true
								? (data.side[0].one_fourth_vertical_side_cost + data.side[0].one_fourth_side_close_cost).toFixed(2)
								: data.side[0].one_fourth_side_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.right_wall_price);
				}
				if (params.p_b_c_b_r_r == "Three_Fourth_Close") {
					b.right_wall_price =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.right_lean_left_wall_price_changed != true
							? rightLeanData.right_wall_price
							: params.p_v_w == true
								? (data.side[0].three_fourth_vertical_side_cost + data.side[0].three_fourth_side_close_cost).toFixed(2)
								: data.side[0].three_fourth_side_close_cost.toFixed(2);
					t_c_b = parseFloat(t_c_b) + parseFloat(b.right_wall_price);
				}
			}
			//  Right Lean utility calculation
			({ t_c_b, CalCulateRoofUtilityEndPrice } = handleLeanUtility({
				checkFlag: "add_storage_check_right",
				storageKey: "add_storage_right",
				positionKey: "rightLeanStoragePosition",
				depthKey: "leanR_p_d",
				sideCloseKey1: "p_b_c_b_r",
				sideCloseKey2: "p_b_c_b_r_r",
				wallKey: "p_r_w",
				leanStyleKey: "right",
				positionConditionType: "neq",
				leanData: rightLeanData,
				updatedFlagKey: "right_lean_utility_price_changed",
				params,
				data,
				const_var,
				b,
				t_c_b,
				UpdatePriceRecord,
				params, // ✅ ADD THIS
				const_var
			}));

			if (const_var.b_r_p_l_to_a.length > 0 && const_var.b_r_p_l_to_a[params.b_l_t_r_pR] != undefined) {
				if (const_var.b_r_p_l_to_a[params.b_l_t_r_pR].cost_type == "%") {
					var splitVal =
						const_var.b_r_p_l_to_a[params.b_l_t_r_pR].percentage_of != undefined && const_var.b_r_p_l_to_a[params.b_l_t_r_pR].percentage_of != 0
							? const_var.b_r_p_l_to_a[params.b_l_t_r_pR].percentage_of.split(",")
							: 0;
					var splval = 0;
					if (splitVal != 0) {
						if (splitVal.includes("1") != false) {
							splval = splval + CalCulateRoofBasePrice;
						}
						if (splitVal.includes("2") != false) {
							if (CalCulateRoofUtilityEndPrice != 0) {
								splval = splval + CalCulateRoofUtilityEndPrice;
							}
							splval = splval + CalCulateRoofEndClosePrice;
						}
						if (splitVal.includes("3") != false) {
							splval = splval + CalCulateRoofEndGablePrice;
						}
					} else {
						splval = splval + CalCulateRoofBasePrice;
					}
					var finalCertPrice =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.right_lean_roof_pitch_price_changed != true
							? rightLeanData.roof_pitch_price
							: const_var.b_r_p_l_to_a[params.b_l_t_r_pR]
								? convertToTwoDecimalNumber((splval * const_var.b_r_p_l_to_a[params.b_l_t_r_pR].cost) / 100)
								: 0;
					b.roof_pitch = const_var.b_r_p_l_to_a[params.b_l_t_r_pR].roof_pitch;
					b.roof_pitch_name = const_var.b_r_p_l_to_a[params.b_l_t_r_pR].roof_pitch;
					b.roof_pitch_custom_name = const_var.b_r_p_l_to_a[params.b_l_t_r_pR]?.custom_name;
					b.roof_pitch_price = utlis.convertToTwoDecimalNumber(finalCertPrice);
					t_c_b = parseFloat(t_c_b) + parseFloat(finalCertPrice);
				} else {
					var finalCertPrice =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.right_lean_roof_pitch_price_changed != true
							? rightLeanData.roof_pitch_price
							: const_var.b_r_p_l_to_a[params.b_l_t_r_pR]
								? const_var.b_r_p_l_to_a[params.b_l_t_r_pR].cost
								: 0;
					b.roof_pitch = const_var.b_r_p_l_to_a[params.b_l_t_r_pR].roof_pitch;
					b.roof_pitch_name = const_var.b_r_p_l_to_a[params.b_l_t_r_pR].roof_pitch;
					b.roof_pitch_custom_name = const_var.b_r_p_l_to_a[params.b_l_t_r_pR]?.custom_name;
					b.roof_pitch_price = utlis.convertToTwoDecimalNumber(finalCertPrice);
					t_c_b = parseFloat(t_c_b) + parseFloat(finalCertPrice);
				}
			} else {
				b.roof_pitch = "3/12";
				b.roof_pitch_name = "3/12";
				b.roof_pitch_price = 0;
			}
			if (checkRightCertificate) {
				if (params.p_i_s == "1") {
				} else {
				}
			}
			if (params.leanR_p_e_i == "other") {
				b.certificate = { gauge: 0, certified: 1, has_double_leg: 0, has_ladder_leg: 0, has_other_leg: 0, height: 0, id: -1, cost: 0, is_default: "no", length: 0, map_id: 0, name: "Other" };
				b.certificate_other_name = params.leanR_p_e_i_other != "" ? params.leanR_p_e_i_other : "Other";
				b.certificate_price = UpdatePriceRecord == true && const_var.UpdatedPriceData.certificate_price_changed != true ? rightLeanData.certificate_price : 0;
			}
			if (params.continous_right_lean == true) {
				b.continous_lean = true;
			} else {
				b.continous_lean = false;
			}
			b.edit_truss_name =
				const_var.c_m_a[params.p_b_t].trussType != undefined && const_var.c_m_a[params.p_b_t].trussType.length > 0 ? params["trussType"] : const_var.c_m_a[params.p_b_t].trussType[0].name.replace(/[0-9]/g, "");

			if (b.leanto_style === "gable") {
				const trussPrice = trussCalcuateForGableLean(params, 0, b, rightLeanData, UpdatePriceRecord);
				if (trussPrice > 0) {
					t_c_b += trussPrice;
				}
			}

			b.pricing_data = data;
			b.t_c_b = parseFloat(t_c_b);

			const_var.leanto.push(b);
			const_var.UpdatedPriceData.leanto.push(b);
		} else {
			removeDataFromArray(2);
		}
		cP(const_var.a_p_d_a, true);
	};

	return {
		cPforFLeanOnly,
		cPforBLeanOnly,
		cPforLLeanOnly,
		cPforRLeanOnly
	};
};
